/* Non-critical fonts */
document.addEventListener("DOMContentLoaded",function(){var style=document.createElement("style");style.textContent=`@font-face{font-family:"BigMoore";src:url("https://d2izr24fok1gc0.cloudfront.net/nwkw_spring_sale/BigMoore-Regular.otf");font-weight:400;font-style:normal;font-display:swap;}@font-face{font-family:"Figtree";src:url("https://d2izr24fok1gc0.cloudfront.net/nwkw_spring_sale/Figtree-Light.ttf");font-weight:300;font-style:normal;font-display:swap;}@font-face{font-family:"Figtree";src:url("https://d2izr24fok1gc0.cloudfront.net/nwkw_spring_sale/Figtree-Regular.ttf");font-weight:400;font-style:normal;font-display:swap;}@font-face{font-family:"Figtree";src:url("https://d2izr24fok1gc0.cloudfront.net/nwkw_spring_sale/Figtree-Medium.ttf");font-weight:500;font-style:normal;font-display:swap;}@font-face{font-family:"Figtree";src:url("https://d2izr24fok1gc0.cloudfront.net/nwkw_spring_sale/Figtree-Bold.ttf");font-weight:700;font-style:normal;font-display:swap;}`;document.head.appendChild(style);});
/* Start Section nwkw_spring_sale_link_grid_F8EEPY */
document.addEventListener('DOMContentLoaded',function(){var Swipes=new Swiper('.nwkw_bfcm_link_grid-template--nwkw_spring_sale_link_grid_F8EEPY.swiper',{loop:false,slidesPerView:3,spaceBetween:20,grabCursor:true,centeredSlides:false,initialSlide:0,roundLengths:true,speed:1500,breakpoints:{0:{slidesPerView:3,spaceBetween:15,centeredSlides:false,loop:false,initialSlide:0,},768:{slidesPerView:5,centeredSlides:false,spaceBetween:24,loop:false,initialSlide:0,},},on:{click:function(swiper,event){swiper.slides.forEach(function(slide){slide.classList.remove('active-slide');});const clickedSlide=swiper.clickedSlide;if(clickedSlide){clickedSlide.classList.add('active-slide');}}}});});
/* End Section nwkw_spring_sale_link_grid_F8EEPY */
/* Start Section nwkw_val_zive_25mar_wwai_hero_banner_1_zYgM6T */
document.addEventListener('DOMContentLoaded',()=>{const timerElement=document.querySelector('.timer_countdown_time_text_class_section p');if(!timerElement)return;function parseEndTime(){const endDateText=timerElement.innerText;const[day,month,year,hour,minute,second]=endDateText.split(/[- :]/);const endDate=new Date(`${month}-${day}-${year}${hour}:${minute}:${second}`);return endDate.getTime();}
let endTime=parseEndTime();function getNewEndTime(){return new Date().getTime()+48*60*60*1000;}
function updateCountdown(){const now=new Date().getTime();let remainingTime=endTime-now;if(remainingTime<=0){if(endTime<(now+24*60*60*1000)){endTime=now+24*60*60*1000;}else{endTime=getNewEndTime();}
remainingTime=endTime-now;}
const days=Math.floor(remainingTime/(1000*60*60*24));const hours=Math.floor((remainingTime/(1000*60*60))%24);const minutes=Math.floor((remainingTime/(1000*60))%60);const seconds=Math.floor((remainingTime/1000)%60);timerElement.innerText=`${days}d ${hours}h ${minutes}m ${seconds}s`;}
setInterval(updateCountdown,1000);updateCountdown();});
/* End Section nwkw_val_zive_25mar_wwai_hero_banner_1_zYgM6T */
/* Start Section grid_products_list_DmULXj */
window.customProductEventLoggingEnabled=false;window.variantConnectionLoggingEnabled=false;window.variantDispatchLoggingEnabled=false;window.heightEqualizeLogging=false;function extractProductVariantSelectors(){const selectors=document.querySelectorAll('product-variant-selector');const results=[];selectors.forEach(selector=>{const productGroup=selector.getAttribute('product_group');if(!productGroup)return;results.push(`${productGroup}:product:${productGroup}`);});console.log(results.join(',\n'));}
if(!window.WWAI_VIRTUAL_BUNDLE_CONFIG){window.WWAI_VIRTUAL_BUNDLE_CONFIG={"template--24302590886205__myk_zive_19feb_wwai_product_cards_bqDEyD__product_card_mz3GfH":[{handle:"g-fusion-steak-knife",variantOptions:["Miyuki",null,null],quantity:8},{handle:"arete-steak-knife-block",variantOptions:["Maple",null,null],quantity:1}],"build-your-steak-knife-set":[{handle:"g-fusion-steak-knife",variantOptions:["Peacock",null,null],quantity:6}],"template--24302590886205__myk_zive_19feb_wwai_product_cards_6nLFtL__product_card_eKMyWA":[{handle:"g-fusion-9-chef-knife",variantOptions:["Miyuki",null,null],quantity:1},{handle:"g-fusion-9-superbread",variantOptions:["Miyuki",null,null],quantity:1},{handle:"g-fusion-7-teton-edge-santoku",variantOptions:["Miyuki",null,null],quantity:1},{handle:"g-fusion-6-petty-utility-knife",variantOptions:["Miyuki",null,null],quantity:1},{handle:"g-fusion-6-deli",variantOptions:["Miyuki",null,null],quantity:1},{handle:"g-fusion-5-chopper",variantOptions:["Miyuki",null,null],quantity:1},{handle:"g-fusion-3-paring-knife",variantOptions:["Miyuki",null,null],quantity:1},{handle:"arete-knife-block",variantOptions:["Walnut",null,null],quantity:1}]};}else{;}
(function(){var sectionId="shopify-section-template--grid_products_list_DmULXj";window.SECTION_DATA=window.SECTION_DATA||{};window.SECTION_DATA[sectionId]=window.SECTION_DATA[sectionId]||{};Object.assign(window.SECTION_DATA[sectionId],{defaultVariantDispatchConfig:{defaultProduct:"product",defaultVariantOption1:"__wwai_first__",defaultVariantOption2:null,defaultVariantOption3:null},variantDispatchConfig:{"arete-knife-block":{defaultProduct:"product",defaultVariantOption1:"Walnut",defaultVariantOption2:null,defaultVariantOption3:null},"arete-steak-knife-block":{defaultProduct:"product",defaultVariantOption1:"Maple",defaultVariantOption2:null,defaultVariantOption3:null},"build-your-steak-knife-set":{defaultProduct:"product",defaultVariantOption1:"Default Title",defaultVariantOption2:null,defaultVariantOption3:null}}});})();function extractProductVariantSelectorsInSection(sectionId){const section=document.getElementById(sectionId);if(!section){console.warn(`⚠️ Section with id"${sectionId}"not found.`);return[];}
const selectors=section.querySelectorAll('product-variant-selector');const results=[];selectors.forEach(selector=>{const productGroup=selector.getAttribute('product_group');if(!productGroup)return;results.push(productGroup);});return results;}
(function(){const sectionId="shopify-section-template--grid_products_list_DmULXj";document.addEventListener("DOMContentLoaded",function(){if(window.WWAIUtils?.inferCurrencyDetails&&window.SECTION_DATA?.["all_sections"]?.storeData?.dummyPrice){window.WWAIUtils.inferCurrencyDetails(window.SECTION_DATA["all_sections"].storeData.dummyPrice);if(window.WWAIUtils?.formatShopifyPrice){const sampleFormatted=window.WWAIUtils.formatShopifyPrice(1299);window.customProductEventLoggingEnabled&&console.log(`🧪 Sample formatted price for 1299 cents:${sampleFormatted}`);}else{console.warn("⚠️ formatShopifyPrice is not defined.");}}else{console.warn(`⚠️ inferCurrencyDetails or dummy_price not available for ${sectionId}`);}
if(window.WWAIUtils?.updateVariantSubscriptionMapping){window.WWAIUtils.updateVariantSubscriptionMapping(sectionId);}else{console.warn(`⚠️ updateVariantSubscriptionMapping not defined for ${sectionId}`);}
const config=window.SECTION_DATA?.[sectionId]?.variantDispatchConfig;const default_config=window.SECTION_DATA?.[sectionId]?.defaultVariantDispatchConfig;const product_group_in_section=extractProductVariantSelectorsInSection(sectionId);if(window.WWAIUtils?.initializeVariantDispatch&&(config||default_config)){product_group_in_section.forEach(function(productGroup){window.WWAIUtils.initializeVariantDispatch(sectionId,productGroup);});}else{console.warn(`⚠️ WWAIUtils.initializeVariantDispatch or variantDispatchConfig missing for section:${sectionId}`);}});})();(function(){const sectionId="shopify-section-template--grid_products_list_DmULXj";const productGroups=extractProductVariantSelectorsInSection(sectionId);const shouldRegisterVariantListener=false;if(window.customProductEventLoggingEnabled){console.log(`🧪[${sectionId}]WWAI Init — productGroups:`,productGroups);console.log(`🧪[${sectionId}]WWAI Init — shouldRegisterVariantListener:`,shouldRegisterVariantListener);}
document.addEventListener("DOMContentLoaded",function(){if(shouldRegisterVariantListener){if(window.WWAIUtils&&typeof window.WWAIUtils.registerSectionEventListener==="function"){productGroups.forEach(function(productGroup){window.WWAIUtils.registerSectionEventListener(sectionId,productGroup,window.WWAI_EVENTS.VARIANT_CHANGED,function(e){console.log(`🧪[${sectionId}]VARIANT_CHANGED triggered for"${productGroup}"`);console.log("🧪 Payload:",e.detail);});});}else{console.warn(`⚠️ WWAIUtils.registerSectionEventListener is not defined for ${sectionId}`);}}});})();window.SECTION_DATA=window.SECTION_DATA||{};window.SECTION_DATA["shopify-section-template--grid_products_list_DmULXj"]=window.SECTION_DATA["shopify-section-template--grid_products_list_DmULXj"]||{};Object.assign(window.SECTION_DATA["shopify-section-template--grid_products_list_DmULXj"],{sectionId:"shopify-section-template--grid_products_list_DmULXj",defaultProductConfig:{discount_percent:0,subscription_discount_percent:25,variant_option_remove_prefix:'Every',default_purchase_type:'subscription'},defaultFlowConfig:{destination:"cart",},productGroupConfig:{}});
/* End Section grid_products_list_DmULXj */
/* Start Section grid_products_list_fmxAPg */
window.customProductEventLoggingEnabled=false;window.variantConnectionLoggingEnabled=false;window.variantDispatchLoggingEnabled=false;window.heightEqualizeLogging=false;function extractProductVariantSelectors(){const selectors=document.querySelectorAll('product-variant-selector');const results=[];selectors.forEach(selector=>{const productGroup=selector.getAttribute('product_group');if(!productGroup)return;results.push(`${productGroup}:product:${productGroup}`);});console.log(results.join(',\n'));}
if(!window.WWAI_VIRTUAL_BUNDLE_CONFIG){window.WWAI_VIRTUAL_BUNDLE_CONFIG={"template--24302590886205__myk_zive_19feb_wwai_product_cards_bqDEyD__product_card_mz3GfH":[{handle:"g-fusion-steak-knife",variantOptions:["Miyuki",null,null],quantity:8},{handle:"arete-steak-knife-block",variantOptions:["Maple",null,null],quantity:1}],"build-your-steak-knife-set":[{handle:"g-fusion-steak-knife",variantOptions:["Peacock",null,null],quantity:6}],"template--24302590886205__myk_zive_19feb_wwai_product_cards_6nLFtL__product_card_eKMyWA":[{handle:"g-fusion-9-chef-knife",variantOptions:["Miyuki",null,null],quantity:1},{handle:"g-fusion-9-superbread",variantOptions:["Miyuki",null,null],quantity:1},{handle:"g-fusion-7-teton-edge-santoku",variantOptions:["Miyuki",null,null],quantity:1},{handle:"g-fusion-6-petty-utility-knife",variantOptions:["Miyuki",null,null],quantity:1},{handle:"g-fusion-6-deli",variantOptions:["Miyuki",null,null],quantity:1},{handle:"g-fusion-5-chopper",variantOptions:["Miyuki",null,null],quantity:1},{handle:"g-fusion-3-paring-knife",variantOptions:["Miyuki",null,null],quantity:1},{handle:"arete-knife-block",variantOptions:["Walnut",null,null],quantity:1}]};}else{;}
(function(){var sectionId="shopify-section-template--grid_products_list_fmxAPg";window.SECTION_DATA=window.SECTION_DATA||{};window.SECTION_DATA[sectionId]=window.SECTION_DATA[sectionId]||{};Object.assign(window.SECTION_DATA[sectionId],{defaultVariantDispatchConfig:{defaultProduct:"product",defaultVariantOption1:"__wwai_first__",defaultVariantOption2:null,defaultVariantOption3:null},variantDispatchConfig:{"arete-knife-block":{defaultProduct:"product",defaultVariantOption1:"Walnut",defaultVariantOption2:null,defaultVariantOption3:null},"arete-steak-knife-block":{defaultProduct:"product",defaultVariantOption1:"Maple",defaultVariantOption2:null,defaultVariantOption3:null},"build-your-steak-knife-set":{defaultProduct:"product",defaultVariantOption1:"Default Title",defaultVariantOption2:null,defaultVariantOption3:null}}});})();function extractProductVariantSelectorsInSection(sectionId){const section=document.getElementById(sectionId);if(!section){console.warn(`⚠️ Section with id"${sectionId}"not found.`);return[];}
const selectors=section.querySelectorAll('product-variant-selector');const results=[];selectors.forEach(selector=>{const productGroup=selector.getAttribute('product_group');if(!productGroup)return;results.push(productGroup);});return results;}
(function(){const sectionId="shopify-section-template--grid_products_list_fmxAPg";document.addEventListener("DOMContentLoaded",function(){if(window.WWAIUtils?.inferCurrencyDetails&&window.SECTION_DATA?.["all_sections"]?.storeData?.dummyPrice){window.WWAIUtils.inferCurrencyDetails(window.SECTION_DATA["all_sections"].storeData.dummyPrice);if(window.WWAIUtils?.formatShopifyPrice){const sampleFormatted=window.WWAIUtils.formatShopifyPrice(1299);window.customProductEventLoggingEnabled&&console.log(`🧪 Sample formatted price for 1299 cents:${sampleFormatted}`);}else{console.warn("⚠️ formatShopifyPrice is not defined.");}}else{console.warn(`⚠️ inferCurrencyDetails or dummy_price not available for ${sectionId}`);}
if(window.WWAIUtils?.updateVariantSubscriptionMapping){window.WWAIUtils.updateVariantSubscriptionMapping(sectionId);}else{console.warn(`⚠️ updateVariantSubscriptionMapping not defined for ${sectionId}`);}
const config=window.SECTION_DATA?.[sectionId]?.variantDispatchConfig;const default_config=window.SECTION_DATA?.[sectionId]?.defaultVariantDispatchConfig;const product_group_in_section=extractProductVariantSelectorsInSection(sectionId);if(window.WWAIUtils?.initializeVariantDispatch&&(config||default_config)){product_group_in_section.forEach(function(productGroup){window.WWAIUtils.initializeVariantDispatch(sectionId,productGroup);});}else{console.warn(`⚠️ WWAIUtils.initializeVariantDispatch or variantDispatchConfig missing for section:${sectionId}`);}});})();(function(){const sectionId="shopify-section-template--grid_products_list_fmxAPg";const productGroups=extractProductVariantSelectorsInSection(sectionId);const shouldRegisterVariantListener=false;if(window.customProductEventLoggingEnabled){console.log(`🧪[${sectionId}]WWAI Init — productGroups:`,productGroups);console.log(`🧪[${sectionId}]WWAI Init — shouldRegisterVariantListener:`,shouldRegisterVariantListener);}
document.addEventListener("DOMContentLoaded",function(){if(shouldRegisterVariantListener){if(window.WWAIUtils&&typeof window.WWAIUtils.registerSectionEventListener==="function"){productGroups.forEach(function(productGroup){window.WWAIUtils.registerSectionEventListener(sectionId,productGroup,window.WWAI_EVENTS.VARIANT_CHANGED,function(e){console.log(`🧪[${sectionId}]VARIANT_CHANGED triggered for"${productGroup}"`);console.log("🧪 Payload:",e.detail);});});}else{console.warn(`⚠️ WWAIUtils.registerSectionEventListener is not defined for ${sectionId}`);}}});})();window.SECTION_DATA=window.SECTION_DATA||{};window.SECTION_DATA["shopify-section-template--grid_products_list_fmxAPg"]=window.SECTION_DATA["shopify-section-template--grid_products_list_fmxAPg"]||{};Object.assign(window.SECTION_DATA["shopify-section-template--grid_products_list_fmxAPg"],{sectionId:"shopify-section-template--grid_products_list_fmxAPg",defaultProductConfig:{discount_percent:0,subscription_discount_percent:25,variant_option_remove_prefix:'Every',default_purchase_type:'subscription'},defaultFlowConfig:{destination:"cart",},productGroupConfig:{}});
/* End Section grid_products_list_fmxAPg */
/* Start Section grid_products_list_cD9FLW */
window.customProductEventLoggingEnabled=false;window.variantConnectionLoggingEnabled=false;window.variantDispatchLoggingEnabled=false;window.heightEqualizeLogging=false;function extractProductVariantSelectors(){const selectors=document.querySelectorAll('product-variant-selector');const results=[];selectors.forEach(selector=>{const productGroup=selector.getAttribute('product_group');if(!productGroup)return;results.push(`${productGroup}:product:${productGroup}`);});console.log(results.join(',\n'));}
if(!window.WWAI_VIRTUAL_BUNDLE_CONFIG){window.WWAI_VIRTUAL_BUNDLE_CONFIG={"template--24302590886205__myk_zive_19feb_wwai_product_cards_bqDEyD__product_card_mz3GfH":[{handle:"g-fusion-steak-knife",variantOptions:["Miyuki",null,null],quantity:8},{handle:"arete-steak-knife-block",variantOptions:["Maple",null,null],quantity:1}],"build-your-steak-knife-set":[{handle:"g-fusion-steak-knife",variantOptions:["Peacock",null,null],quantity:6}],"template--24302590886205__myk_zive_19feb_wwai_product_cards_6nLFtL__product_card_eKMyWA":[{handle:"g-fusion-9-chef-knife",variantOptions:["Miyuki",null,null],quantity:1},{handle:"g-fusion-9-superbread",variantOptions:["Miyuki",null,null],quantity:1},{handle:"g-fusion-7-teton-edge-santoku",variantOptions:["Miyuki",null,null],quantity:1},{handle:"g-fusion-6-petty-utility-knife",variantOptions:["Miyuki",null,null],quantity:1},{handle:"g-fusion-6-deli",variantOptions:["Miyuki",null,null],quantity:1},{handle:"g-fusion-5-chopper",variantOptions:["Miyuki",null,null],quantity:1},{handle:"g-fusion-3-paring-knife",variantOptions:["Miyuki",null,null],quantity:1},{handle:"arete-knife-block",variantOptions:["Walnut",null,null],quantity:1}]};}else{;}
(function(){var sectionId="shopify-section-template--grid_products_list_cD9FLW";window.SECTION_DATA=window.SECTION_DATA||{};window.SECTION_DATA[sectionId]=window.SECTION_DATA[sectionId]||{};Object.assign(window.SECTION_DATA[sectionId],{defaultVariantDispatchConfig:{defaultProduct:"product",defaultVariantOption1:"__wwai_first__",defaultVariantOption2:null,defaultVariantOption3:null},variantDispatchConfig:{"arete-knife-block":{defaultProduct:"product",defaultVariantOption1:"Walnut",defaultVariantOption2:null,defaultVariantOption3:null},"arete-steak-knife-block":{defaultProduct:"product",defaultVariantOption1:"Maple",defaultVariantOption2:null,defaultVariantOption3:null},"build-your-steak-knife-set":{defaultProduct:"product",defaultVariantOption1:"Default Title",defaultVariantOption2:null,defaultVariantOption3:null}}});})();function extractProductVariantSelectorsInSection(sectionId){const section=document.getElementById(sectionId);if(!section){console.warn(`⚠️ Section with id"${sectionId}"not found.`);return[];}
const selectors=section.querySelectorAll('product-variant-selector');const results=[];selectors.forEach(selector=>{const productGroup=selector.getAttribute('product_group');if(!productGroup)return;results.push(productGroup);});return results;}
(function(){const sectionId="shopify-section-template--grid_products_list_cD9FLW";document.addEventListener("DOMContentLoaded",function(){if(window.WWAIUtils?.inferCurrencyDetails&&window.SECTION_DATA?.["all_sections"]?.storeData?.dummyPrice){window.WWAIUtils.inferCurrencyDetails(window.SECTION_DATA["all_sections"].storeData.dummyPrice);if(window.WWAIUtils?.formatShopifyPrice){const sampleFormatted=window.WWAIUtils.formatShopifyPrice(1299);window.customProductEventLoggingEnabled&&console.log(`🧪 Sample formatted price for 1299 cents:${sampleFormatted}`);}else{console.warn("⚠️ formatShopifyPrice is not defined.");}}else{console.warn(`⚠️ inferCurrencyDetails or dummy_price not available for ${sectionId}`);}
if(window.WWAIUtils?.updateVariantSubscriptionMapping){window.WWAIUtils.updateVariantSubscriptionMapping(sectionId);}else{console.warn(`⚠️ updateVariantSubscriptionMapping not defined for ${sectionId}`);}
const config=window.SECTION_DATA?.[sectionId]?.variantDispatchConfig;const default_config=window.SECTION_DATA?.[sectionId]?.defaultVariantDispatchConfig;const product_group_in_section=extractProductVariantSelectorsInSection(sectionId);if(window.WWAIUtils?.initializeVariantDispatch&&(config||default_config)){product_group_in_section.forEach(function(productGroup){window.WWAIUtils.initializeVariantDispatch(sectionId,productGroup);});}else{console.warn(`⚠️ WWAIUtils.initializeVariantDispatch or variantDispatchConfig missing for section:${sectionId}`);}});})();(function(){const sectionId="shopify-section-template--grid_products_list_cD9FLW";const productGroups=extractProductVariantSelectorsInSection(sectionId);const shouldRegisterVariantListener=false;if(window.customProductEventLoggingEnabled){console.log(`🧪[${sectionId}]WWAI Init — productGroups:`,productGroups);console.log(`🧪[${sectionId}]WWAI Init — shouldRegisterVariantListener:`,shouldRegisterVariantListener);}
document.addEventListener("DOMContentLoaded",function(){if(shouldRegisterVariantListener){if(window.WWAIUtils&&typeof window.WWAIUtils.registerSectionEventListener==="function"){productGroups.forEach(function(productGroup){window.WWAIUtils.registerSectionEventListener(sectionId,productGroup,window.WWAI_EVENTS.VARIANT_CHANGED,function(e){console.log(`🧪[${sectionId}]VARIANT_CHANGED triggered for"${productGroup}"`);console.log("🧪 Payload:",e.detail);});});}else{console.warn(`⚠️ WWAIUtils.registerSectionEventListener is not defined for ${sectionId}`);}}});})();window.SECTION_DATA=window.SECTION_DATA||{};window.SECTION_DATA["shopify-section-template--grid_products_list_cD9FLW"]=window.SECTION_DATA["shopify-section-template--grid_products_list_cD9FLW"]||{};Object.assign(window.SECTION_DATA["shopify-section-template--grid_products_list_cD9FLW"],{sectionId:"shopify-section-template--grid_products_list_cD9FLW",defaultProductConfig:{discount_percent:0,subscription_discount_percent:25,variant_option_remove_prefix:'Every',default_purchase_type:'subscription'},defaultFlowConfig:{destination:"cart",},productGroupConfig:{}});
/* End Section grid_products_list_cD9FLW */
/* Start Section grid_products_list_XBF9Uk */
window.customProductEventLoggingEnabled=false;window.variantConnectionLoggingEnabled=false;window.variantDispatchLoggingEnabled=false;window.heightEqualizeLogging=false;function extractProductVariantSelectors(){const selectors=document.querySelectorAll('product-variant-selector');const results=[];selectors.forEach(selector=>{const productGroup=selector.getAttribute('product_group');if(!productGroup)return;results.push(`${productGroup}:product:${productGroup}`);});console.log(results.join(',\n'));}
if(!window.WWAI_VIRTUAL_BUNDLE_CONFIG){window.WWAI_VIRTUAL_BUNDLE_CONFIG={"template--24302590886205__myk_zive_19feb_wwai_product_cards_bqDEyD__product_card_mz3GfH":[{handle:"g-fusion-steak-knife",variantOptions:["Miyuki",null,null],quantity:8},{handle:"arete-steak-knife-block",variantOptions:["Maple",null,null],quantity:1}],"build-your-steak-knife-set":[{handle:"g-fusion-steak-knife",variantOptions:["Peacock",null,null],quantity:6}],"template--24302590886205__myk_zive_19feb_wwai_product_cards_6nLFtL__product_card_eKMyWA":[{handle:"g-fusion-9-chef-knife",variantOptions:["Miyuki",null,null],quantity:1},{handle:"g-fusion-9-superbread",variantOptions:["Miyuki",null,null],quantity:1},{handle:"g-fusion-7-teton-edge-santoku",variantOptions:["Miyuki",null,null],quantity:1},{handle:"g-fusion-6-petty-utility-knife",variantOptions:["Miyuki",null,null],quantity:1},{handle:"g-fusion-6-deli",variantOptions:["Miyuki",null,null],quantity:1},{handle:"g-fusion-5-chopper",variantOptions:["Miyuki",null,null],quantity:1},{handle:"g-fusion-3-paring-knife",variantOptions:["Miyuki",null,null],quantity:1},{handle:"arete-knife-block",variantOptions:["Walnut",null,null],quantity:1}]};}else{;}
(function(){var sectionId="shopify-section-template--grid_products_list_XBF9Uk";window.SECTION_DATA=window.SECTION_DATA||{};window.SECTION_DATA[sectionId]=window.SECTION_DATA[sectionId]||{};Object.assign(window.SECTION_DATA[sectionId],{defaultVariantDispatchConfig:{defaultProduct:"product",defaultVariantOption1:"__wwai_first__",defaultVariantOption2:null,defaultVariantOption3:null},variantDispatchConfig:{"arete-knife-block":{defaultProduct:"product",defaultVariantOption1:"Walnut",defaultVariantOption2:null,defaultVariantOption3:null},"arete-steak-knife-block":{defaultProduct:"product",defaultVariantOption1:"Maple",defaultVariantOption2:null,defaultVariantOption3:null},"build-your-steak-knife-set":{defaultProduct:"product",defaultVariantOption1:"Default Title",defaultVariantOption2:null,defaultVariantOption3:null}}});})();function extractProductVariantSelectorsInSection(sectionId){const section=document.getElementById(sectionId);if(!section){console.warn(`⚠️ Section with id"${sectionId}"not found.`);return[];}
const selectors=section.querySelectorAll('product-variant-selector');const results=[];selectors.forEach(selector=>{const productGroup=selector.getAttribute('product_group');if(!productGroup)return;results.push(productGroup);});return results;}
(function(){const sectionId="shopify-section-template--grid_products_list_XBF9Uk";document.addEventListener("DOMContentLoaded",function(){if(window.WWAIUtils?.inferCurrencyDetails&&window.SECTION_DATA?.["all_sections"]?.storeData?.dummyPrice){window.WWAIUtils.inferCurrencyDetails(window.SECTION_DATA["all_sections"].storeData.dummyPrice);if(window.WWAIUtils?.formatShopifyPrice){const sampleFormatted=window.WWAIUtils.formatShopifyPrice(1299);window.customProductEventLoggingEnabled&&console.log(`🧪 Sample formatted price for 1299 cents:${sampleFormatted}`);}else{console.warn("⚠️ formatShopifyPrice is not defined.");}}else{console.warn(`⚠️ inferCurrencyDetails or dummy_price not available for ${sectionId}`);}
if(window.WWAIUtils?.updateVariantSubscriptionMapping){window.WWAIUtils.updateVariantSubscriptionMapping(sectionId);}else{console.warn(`⚠️ updateVariantSubscriptionMapping not defined for ${sectionId}`);}
const config=window.SECTION_DATA?.[sectionId]?.variantDispatchConfig;const default_config=window.SECTION_DATA?.[sectionId]?.defaultVariantDispatchConfig;const product_group_in_section=extractProductVariantSelectorsInSection(sectionId);if(window.WWAIUtils?.initializeVariantDispatch&&(config||default_config)){product_group_in_section.forEach(function(productGroup){window.WWAIUtils.initializeVariantDispatch(sectionId,productGroup);});}else{console.warn(`⚠️ WWAIUtils.initializeVariantDispatch or variantDispatchConfig missing for section:${sectionId}`);}});})();(function(){const sectionId="shopify-section-template--grid_products_list_XBF9Uk";const productGroups=extractProductVariantSelectorsInSection(sectionId);const shouldRegisterVariantListener=false;if(window.customProductEventLoggingEnabled){console.log(`🧪[${sectionId}]WWAI Init — productGroups:`,productGroups);console.log(`🧪[${sectionId}]WWAI Init — shouldRegisterVariantListener:`,shouldRegisterVariantListener);}
document.addEventListener("DOMContentLoaded",function(){if(shouldRegisterVariantListener){if(window.WWAIUtils&&typeof window.WWAIUtils.registerSectionEventListener==="function"){productGroups.forEach(function(productGroup){window.WWAIUtils.registerSectionEventListener(sectionId,productGroup,window.WWAI_EVENTS.VARIANT_CHANGED,function(e){console.log(`🧪[${sectionId}]VARIANT_CHANGED triggered for"${productGroup}"`);console.log("🧪 Payload:",e.detail);});});}else{console.warn(`⚠️ WWAIUtils.registerSectionEventListener is not defined for ${sectionId}`);}}});})();window.SECTION_DATA=window.SECTION_DATA||{};window.SECTION_DATA["shopify-section-template--grid_products_list_XBF9Uk"]=window.SECTION_DATA["shopify-section-template--grid_products_list_XBF9Uk"]||{};Object.assign(window.SECTION_DATA["shopify-section-template--grid_products_list_XBF9Uk"],{sectionId:"shopify-section-template--grid_products_list_XBF9Uk",defaultProductConfig:{discount_percent:0,subscription_discount_percent:25,variant_option_remove_prefix:'Every',default_purchase_type:'subscription'},defaultFlowConfig:{destination:"cart",},productGroupConfig:{}});
/* End Section grid_products_list_XBF9Uk */
/* Start Section grid_products_list_N9hBBf */
window.customProductEventLoggingEnabled=false;window.variantConnectionLoggingEnabled=false;window.variantDispatchLoggingEnabled=false;window.heightEqualizeLogging=false;function extractProductVariantSelectors(){const selectors=document.querySelectorAll('product-variant-selector');const results=[];selectors.forEach(selector=>{const productGroup=selector.getAttribute('product_group');if(!productGroup)return;results.push(`${productGroup}:product:${productGroup}`);});console.log(results.join(',\n'));}
if(!window.WWAI_VIRTUAL_BUNDLE_CONFIG){window.WWAI_VIRTUAL_BUNDLE_CONFIG={"template--24302590886205__myk_zive_19feb_wwai_product_cards_bqDEyD__product_card_mz3GfH":[{handle:"g-fusion-steak-knife",variantOptions:["Miyuki",null,null],quantity:8},{handle:"arete-steak-knife-block",variantOptions:["Maple",null,null],quantity:1}],"build-your-steak-knife-set":[{handle:"g-fusion-steak-knife",variantOptions:["Peacock",null,null],quantity:6}],"template--24302590886205__myk_zive_19feb_wwai_product_cards_6nLFtL__product_card_eKMyWA":[{handle:"g-fusion-9-chef-knife",variantOptions:["Miyuki",null,null],quantity:1},{handle:"g-fusion-9-superbread",variantOptions:["Miyuki",null,null],quantity:1},{handle:"g-fusion-7-teton-edge-santoku",variantOptions:["Miyuki",null,null],quantity:1},{handle:"g-fusion-6-petty-utility-knife",variantOptions:["Miyuki",null,null],quantity:1},{handle:"g-fusion-6-deli",variantOptions:["Miyuki",null,null],quantity:1},{handle:"g-fusion-5-chopper",variantOptions:["Miyuki",null,null],quantity:1},{handle:"g-fusion-3-paring-knife",variantOptions:["Miyuki",null,null],quantity:1},{handle:"arete-knife-block",variantOptions:["Walnut",null,null],quantity:1}]};}else{;}
(function(){var sectionId="shopify-section-template--grid_products_list_N9hBBf";window.SECTION_DATA=window.SECTION_DATA||{};window.SECTION_DATA[sectionId]=window.SECTION_DATA[sectionId]||{};Object.assign(window.SECTION_DATA[sectionId],{defaultVariantDispatchConfig:{defaultProduct:"product",defaultVariantOption1:"__wwai_first__",defaultVariantOption2:null,defaultVariantOption3:null},variantDispatchConfig:{"arete-knife-block":{defaultProduct:"product",defaultVariantOption1:"Walnut",defaultVariantOption2:null,defaultVariantOption3:null},"arete-steak-knife-block":{defaultProduct:"product",defaultVariantOption1:"Maple",defaultVariantOption2:null,defaultVariantOption3:null},"build-your-steak-knife-set":{defaultProduct:"product",defaultVariantOption1:"Default Title",defaultVariantOption2:null,defaultVariantOption3:null}}});})();function extractProductVariantSelectorsInSection(sectionId){const section=document.getElementById(sectionId);if(!section){console.warn(`⚠️ Section with id"${sectionId}"not found.`);return[];}
const selectors=section.querySelectorAll('product-variant-selector');const results=[];selectors.forEach(selector=>{const productGroup=selector.getAttribute('product_group');if(!productGroup)return;results.push(productGroup);});return results;}
(function(){const sectionId="shopify-section-template--grid_products_list_N9hBBf";document.addEventListener("DOMContentLoaded",function(){if(window.WWAIUtils?.inferCurrencyDetails&&window.SECTION_DATA?.["all_sections"]?.storeData?.dummyPrice){window.WWAIUtils.inferCurrencyDetails(window.SECTION_DATA["all_sections"].storeData.dummyPrice);if(window.WWAIUtils?.formatShopifyPrice){const sampleFormatted=window.WWAIUtils.formatShopifyPrice(1299);window.customProductEventLoggingEnabled&&console.log(`🧪 Sample formatted price for 1299 cents:${sampleFormatted}`);}else{console.warn("⚠️ formatShopifyPrice is not defined.");}}else{console.warn(`⚠️ inferCurrencyDetails or dummy_price not available for ${sectionId}`);}
if(window.WWAIUtils?.updateVariantSubscriptionMapping){window.WWAIUtils.updateVariantSubscriptionMapping(sectionId);}else{console.warn(`⚠️ updateVariantSubscriptionMapping not defined for ${sectionId}`);}
const config=window.SECTION_DATA?.[sectionId]?.variantDispatchConfig;const default_config=window.SECTION_DATA?.[sectionId]?.defaultVariantDispatchConfig;const product_group_in_section=extractProductVariantSelectorsInSection(sectionId);if(window.WWAIUtils?.initializeVariantDispatch&&(config||default_config)){product_group_in_section.forEach(function(productGroup){window.WWAIUtils.initializeVariantDispatch(sectionId,productGroup);});}else{console.warn(`⚠️ WWAIUtils.initializeVariantDispatch or variantDispatchConfig missing for section:${sectionId}`);}});})();(function(){const sectionId="shopify-section-template--grid_products_list_N9hBBf";const productGroups=extractProductVariantSelectorsInSection(sectionId);const shouldRegisterVariantListener=false;if(window.customProductEventLoggingEnabled){console.log(`🧪[${sectionId}]WWAI Init — productGroups:`,productGroups);console.log(`🧪[${sectionId}]WWAI Init — shouldRegisterVariantListener:`,shouldRegisterVariantListener);}
document.addEventListener("DOMContentLoaded",function(){if(shouldRegisterVariantListener){if(window.WWAIUtils&&typeof window.WWAIUtils.registerSectionEventListener==="function"){productGroups.forEach(function(productGroup){window.WWAIUtils.registerSectionEventListener(sectionId,productGroup,window.WWAI_EVENTS.VARIANT_CHANGED,function(e){console.log(`🧪[${sectionId}]VARIANT_CHANGED triggered for"${productGroup}"`);console.log("🧪 Payload:",e.detail);});});}else{console.warn(`⚠️ WWAIUtils.registerSectionEventListener is not defined for ${sectionId}`);}}});})();window.SECTION_DATA=window.SECTION_DATA||{};window.SECTION_DATA["shopify-section-template--grid_products_list_N9hBBf"]=window.SECTION_DATA["shopify-section-template--grid_products_list_N9hBBf"]||{};Object.assign(window.SECTION_DATA["shopify-section-template--grid_products_list_N9hBBf"],{sectionId:"shopify-section-template--grid_products_list_N9hBBf",defaultProductConfig:{discount_percent:0,subscription_discount_percent:25,variant_option_remove_prefix:'Every',default_purchase_type:'subscription'},defaultFlowConfig:{destination:"cart",},productGroupConfig:{}});
/* End Section grid_products_list_N9hBBf */
/* Start Section grid_products_list_KBiACX */
window.customProductEventLoggingEnabled=false;window.variantConnectionLoggingEnabled=false;window.variantDispatchLoggingEnabled=false;window.heightEqualizeLogging=false;function extractProductVariantSelectors(){const selectors=document.querySelectorAll('product-variant-selector');const results=[];selectors.forEach(selector=>{const productGroup=selector.getAttribute('product_group');if(!productGroup)return;results.push(`${productGroup}:product:${productGroup}`);});console.log(results.join(',\n'));}
if(!window.WWAI_VIRTUAL_BUNDLE_CONFIG){window.WWAI_VIRTUAL_BUNDLE_CONFIG={"template--24302590886205__myk_zive_19feb_wwai_product_cards_bqDEyD__product_card_mz3GfH":[{handle:"g-fusion-steak-knife",variantOptions:["Miyuki",null,null],quantity:8},{handle:"arete-steak-knife-block",variantOptions:["Maple",null,null],quantity:1}],"build-your-steak-knife-set":[{handle:"g-fusion-steak-knife",variantOptions:["Peacock",null,null],quantity:6}],"template--24302590886205__myk_zive_19feb_wwai_product_cards_6nLFtL__product_card_eKMyWA":[{handle:"g-fusion-9-chef-knife",variantOptions:["Miyuki",null,null],quantity:1},{handle:"g-fusion-9-superbread",variantOptions:["Miyuki",null,null],quantity:1},{handle:"g-fusion-7-teton-edge-santoku",variantOptions:["Miyuki",null,null],quantity:1},{handle:"g-fusion-6-petty-utility-knife",variantOptions:["Miyuki",null,null],quantity:1},{handle:"g-fusion-6-deli",variantOptions:["Miyuki",null,null],quantity:1},{handle:"g-fusion-5-chopper",variantOptions:["Miyuki",null,null],quantity:1},{handle:"g-fusion-3-paring-knife",variantOptions:["Miyuki",null,null],quantity:1},{handle:"arete-knife-block",variantOptions:["Walnut",null,null],quantity:1}]};}else{;}
(function(){var sectionId="shopify-section-template--grid_products_list_KBiACX";window.SECTION_DATA=window.SECTION_DATA||{};window.SECTION_DATA[sectionId]=window.SECTION_DATA[sectionId]||{};Object.assign(window.SECTION_DATA[sectionId],{defaultVariantDispatchConfig:{defaultProduct:"product",defaultVariantOption1:"__wwai_first__",defaultVariantOption2:null,defaultVariantOption3:null},variantDispatchConfig:{"arete-knife-block":{defaultProduct:"product",defaultVariantOption1:"Walnut",defaultVariantOption2:null,defaultVariantOption3:null},"arete-steak-knife-block":{defaultProduct:"product",defaultVariantOption1:"Maple",defaultVariantOption2:null,defaultVariantOption3:null},"build-your-steak-knife-set":{defaultProduct:"product",defaultVariantOption1:"Default Title",defaultVariantOption2:null,defaultVariantOption3:null}}});})();function extractProductVariantSelectorsInSection(sectionId){const section=document.getElementById(sectionId);if(!section){console.warn(`⚠️ Section with id"${sectionId}"not found.`);return[];}
const selectors=section.querySelectorAll('product-variant-selector');const results=[];selectors.forEach(selector=>{const productGroup=selector.getAttribute('product_group');if(!productGroup)return;results.push(productGroup);});return results;}
(function(){const sectionId="shopify-section-template--grid_products_list_KBiACX";document.addEventListener("DOMContentLoaded",function(){if(window.WWAIUtils?.inferCurrencyDetails&&window.SECTION_DATA?.["all_sections"]?.storeData?.dummyPrice){window.WWAIUtils.inferCurrencyDetails(window.SECTION_DATA["all_sections"].storeData.dummyPrice);if(window.WWAIUtils?.formatShopifyPrice){const sampleFormatted=window.WWAIUtils.formatShopifyPrice(1299);window.customProductEventLoggingEnabled&&console.log(`🧪 Sample formatted price for 1299 cents:${sampleFormatted}`);}else{console.warn("⚠️ formatShopifyPrice is not defined.");}}else{console.warn(`⚠️ inferCurrencyDetails or dummy_price not available for ${sectionId}`);}
if(window.WWAIUtils?.updateVariantSubscriptionMapping){window.WWAIUtils.updateVariantSubscriptionMapping(sectionId);}else{console.warn(`⚠️ updateVariantSubscriptionMapping not defined for ${sectionId}`);}
const config=window.SECTION_DATA?.[sectionId]?.variantDispatchConfig;const default_config=window.SECTION_DATA?.[sectionId]?.defaultVariantDispatchConfig;const product_group_in_section=extractProductVariantSelectorsInSection(sectionId);if(window.WWAIUtils?.initializeVariantDispatch&&(config||default_config)){product_group_in_section.forEach(function(productGroup){window.WWAIUtils.initializeVariantDispatch(sectionId,productGroup);});}else{console.warn(`⚠️ WWAIUtils.initializeVariantDispatch or variantDispatchConfig missing for section:${sectionId}`);}});})();(function(){const sectionId="shopify-section-template--grid_products_list_KBiACX";const productGroups=extractProductVariantSelectorsInSection(sectionId);const shouldRegisterVariantListener=false;if(window.customProductEventLoggingEnabled){console.log(`🧪[${sectionId}]WWAI Init — productGroups:`,productGroups);console.log(`🧪[${sectionId}]WWAI Init — shouldRegisterVariantListener:`,shouldRegisterVariantListener);}
document.addEventListener("DOMContentLoaded",function(){if(shouldRegisterVariantListener){if(window.WWAIUtils&&typeof window.WWAIUtils.registerSectionEventListener==="function"){productGroups.forEach(function(productGroup){window.WWAIUtils.registerSectionEventListener(sectionId,productGroup,window.WWAI_EVENTS.VARIANT_CHANGED,function(e){console.log(`🧪[${sectionId}]VARIANT_CHANGED triggered for"${productGroup}"`);console.log("🧪 Payload:",e.detail);});});}else{console.warn(`⚠️ WWAIUtils.registerSectionEventListener is not defined for ${sectionId}`);}}});})();window.SECTION_DATA=window.SECTION_DATA||{};window.SECTION_DATA["shopify-section-template--grid_products_list_KBiACX"]=window.SECTION_DATA["shopify-section-template--grid_products_list_KBiACX"]||{};Object.assign(window.SECTION_DATA["shopify-section-template--grid_products_list_KBiACX"],{sectionId:"shopify-section-template--grid_products_list_KBiACX",defaultProductConfig:{discount_percent:0,subscription_discount_percent:25,variant_option_remove_prefix:'Every',default_purchase_type:'subscription'},defaultFlowConfig:{destination:"cart",},productGroupConfig:{}});
/* End Section grid_products_list_KBiACX */
/* Start Section grid_products_list_AeKDaG */
window.customProductEventLoggingEnabled=false;window.variantConnectionLoggingEnabled=false;window.variantDispatchLoggingEnabled=false;window.heightEqualizeLogging=false;function extractProductVariantSelectors(){const selectors=document.querySelectorAll('product-variant-selector');const results=[];selectors.forEach(selector=>{const productGroup=selector.getAttribute('product_group');if(!productGroup)return;results.push(`${productGroup}:product:${productGroup}`);});console.log(results.join(',\n'));}
if(!window.WWAI_VIRTUAL_BUNDLE_CONFIG){window.WWAI_VIRTUAL_BUNDLE_CONFIG={"template--24302590886205__myk_zive_19feb_wwai_product_cards_bqDEyD__product_card_mz3GfH":[{handle:"g-fusion-steak-knife",variantOptions:["Miyuki",null,null],quantity:8},{handle:"arete-steak-knife-block",variantOptions:["Maple",null,null],quantity:1}],"build-your-steak-knife-set":[{handle:"g-fusion-steak-knife",variantOptions:["Peacock",null,null],quantity:6}],"template--24302590886205__myk_zive_19feb_wwai_product_cards_6nLFtL__product_card_eKMyWA":[{handle:"g-fusion-9-chef-knife",variantOptions:["Miyuki",null,null],quantity:1},{handle:"g-fusion-9-superbread",variantOptions:["Miyuki",null,null],quantity:1},{handle:"g-fusion-7-teton-edge-santoku",variantOptions:["Miyuki",null,null],quantity:1},{handle:"g-fusion-6-petty-utility-knife",variantOptions:["Miyuki",null,null],quantity:1},{handle:"g-fusion-6-deli",variantOptions:["Miyuki",null,null],quantity:1},{handle:"g-fusion-5-chopper",variantOptions:["Miyuki",null,null],quantity:1},{handle:"g-fusion-3-paring-knife",variantOptions:["Miyuki",null,null],quantity:1},{handle:"arete-knife-block",variantOptions:["Walnut",null,null],quantity:1}]};}else{;}
(function(){var sectionId="shopify-section-template--grid_products_list_AeKDaG";window.SECTION_DATA=window.SECTION_DATA||{};window.SECTION_DATA[sectionId]=window.SECTION_DATA[sectionId]||{};Object.assign(window.SECTION_DATA[sectionId],{defaultVariantDispatchConfig:{defaultProduct:"product",defaultVariantOption1:"__wwai_first__",defaultVariantOption2:null,defaultVariantOption3:null},variantDispatchConfig:{"arete-knife-block":{defaultProduct:"product",defaultVariantOption1:"Walnut",defaultVariantOption2:null,defaultVariantOption3:null},"arete-steak-knife-block":{defaultProduct:"product",defaultVariantOption1:"Maple",defaultVariantOption2:null,defaultVariantOption3:null},"build-your-steak-knife-set":{defaultProduct:"product",defaultVariantOption1:"Default Title",defaultVariantOption2:null,defaultVariantOption3:null}}});})();function extractProductVariantSelectorsInSection(sectionId){const section=document.getElementById(sectionId);if(!section){console.warn(`⚠️ Section with id"${sectionId}"not found.`);return[];}
const selectors=section.querySelectorAll('product-variant-selector');const results=[];selectors.forEach(selector=>{const productGroup=selector.getAttribute('product_group');if(!productGroup)return;results.push(productGroup);});return results;}
(function(){const sectionId="shopify-section-template--grid_products_list_AeKDaG";document.addEventListener("DOMContentLoaded",function(){if(window.WWAIUtils?.inferCurrencyDetails&&window.SECTION_DATA?.["all_sections"]?.storeData?.dummyPrice){window.WWAIUtils.inferCurrencyDetails(window.SECTION_DATA["all_sections"].storeData.dummyPrice);if(window.WWAIUtils?.formatShopifyPrice){const sampleFormatted=window.WWAIUtils.formatShopifyPrice(1299);window.customProductEventLoggingEnabled&&console.log(`🧪 Sample formatted price for 1299 cents:${sampleFormatted}`);}else{console.warn("⚠️ formatShopifyPrice is not defined.");}}else{console.warn(`⚠️ inferCurrencyDetails or dummy_price not available for ${sectionId}`);}
if(window.WWAIUtils?.updateVariantSubscriptionMapping){window.WWAIUtils.updateVariantSubscriptionMapping(sectionId);}else{console.warn(`⚠️ updateVariantSubscriptionMapping not defined for ${sectionId}`);}
const config=window.SECTION_DATA?.[sectionId]?.variantDispatchConfig;const default_config=window.SECTION_DATA?.[sectionId]?.defaultVariantDispatchConfig;const product_group_in_section=extractProductVariantSelectorsInSection(sectionId);if(window.WWAIUtils?.initializeVariantDispatch&&(config||default_config)){product_group_in_section.forEach(function(productGroup){window.WWAIUtils.initializeVariantDispatch(sectionId,productGroup);});}else{console.warn(`⚠️ WWAIUtils.initializeVariantDispatch or variantDispatchConfig missing for section:${sectionId}`);}});})();(function(){const sectionId="shopify-section-template--grid_products_list_AeKDaG";const productGroups=extractProductVariantSelectorsInSection(sectionId);const shouldRegisterVariantListener=false;if(window.customProductEventLoggingEnabled){console.log(`🧪[${sectionId}]WWAI Init — productGroups:`,productGroups);console.log(`🧪[${sectionId}]WWAI Init — shouldRegisterVariantListener:`,shouldRegisterVariantListener);}
document.addEventListener("DOMContentLoaded",function(){if(shouldRegisterVariantListener){if(window.WWAIUtils&&typeof window.WWAIUtils.registerSectionEventListener==="function"){productGroups.forEach(function(productGroup){window.WWAIUtils.registerSectionEventListener(sectionId,productGroup,window.WWAI_EVENTS.VARIANT_CHANGED,function(e){console.log(`🧪[${sectionId}]VARIANT_CHANGED triggered for"${productGroup}"`);console.log("🧪 Payload:",e.detail);});});}else{console.warn(`⚠️ WWAIUtils.registerSectionEventListener is not defined for ${sectionId}`);}}});})();window.SECTION_DATA=window.SECTION_DATA||{};window.SECTION_DATA["shopify-section-template--grid_products_list_AeKDaG"]=window.SECTION_DATA["shopify-section-template--grid_products_list_AeKDaG"]||{};Object.assign(window.SECTION_DATA["shopify-section-template--grid_products_list_AeKDaG"],{sectionId:"shopify-section-template--grid_products_list_AeKDaG",defaultProductConfig:{discount_percent:0,subscription_discount_percent:25,variant_option_remove_prefix:'Every',default_purchase_type:'subscription'},defaultFlowConfig:{destination:"cart",},productGroupConfig:{}});
/* End Section grid_products_list_AeKDaG */
/* Start Section variant_info_injector */
document.addEventListener('DOMContentLoaded',function(){const variantImageMap={};const variantImages=document.querySelectorAll('.variant-information-section .variant-image');variantImages.forEach(img=>{const optionName=img.getAttribute('data-option-name');const optionValue=img.getAttribute('data-option-value');const imgSrc=img.getAttribute('src');if(!variantImageMap[optionName]){variantImageMap[optionName]={};}
variantImageMap[optionName][optionValue]=imgSrc;});const swatchImages=document.querySelectorAll('label img[data-img-type="variant-swatch"]');swatchImages.forEach(img=>{const optionName=img.getAttribute('data-variant-name');const optionValue=img.getAttribute('data-variant-value');if(variantImageMap[optionName]&&variantImageMap[optionName][optionValue]){const newSrc=variantImageMap[optionName][optionValue];img.src=newSrc;console.log(`Updated swatch for ${optionName}=${optionValue}to ${newSrc}`);}});});
/* End Section variant_info_injector */

document.addEventListener("DOMContentLoaded", function() {
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
            e.preventDefault();

            document.querySelector(this.getAttribute('href')).scrollIntoView({
                behavior: 'smooth'
            });
        });
    });
});

if (!window.ProductCustomHeightEqualizer) {

    class ProductCustomHeightEqualizer extends HTMLElement {
        connectedCallback() {
            this.sectionId = this.getAttribute('section_id');
            this.expectedCards = parseInt(this.getAttribute('data-expected-cards')) || 0;
            this.label = this.dataset.wwaiContainerGroup || 'default-group';
                    
            this.equalizationReady = false;
            // Mutation observer - only when all cards are loaded
            const expectedRoles = this.discoverRoles();
            const EXPECTED_ROLE_COUNT = expectedRoles.length;

            this.mutationObserver = new MutationObserver(() => {
                const cards = this.querySelectorAll('[data-wwai-container-card]');
                const cardsWithAllRoles = Array.from(cards).filter(card => {
                    const roles = card.querySelectorAll('[data-wwai-container-card-role]');
                
                    // Check if card has enough roles
                    if (roles.length < EXPECTED_ROLE_COUNT) return false;
                
                    // Check if at least one role has non-empty content
                    const hasNonEmptyContent = Array.from(roles).some(roleEl => roleEl.innerHTML.trim() !== '');
                    return hasNonEmptyContent;
                });
                            
                window.heightEqualizeLogging && console.log(`[${this.sectionId}] 🟣 Found ${cards.length} cards, ${cardsWithAllRoles.length} have roles defined, expected cards: ${this.expectedCards}`);

                if (cards.length >= this.expectedCards && cardsWithAllRoles.length >= this.expectedCards && this.expectedCards > 0) {
                    window.heightEqualizeLogging && console.info(`[${this.sectionId}] ✅ Detected all (${cards.length}) swiper cards loaded (expected: ${this.expectedCards}), running equalize`);
                    this.equalizationReady = true;
                    this.equalize('mutation-observer');
                    this.mutationObserver.disconnect();
                } else {
                    window.heightEqualizeLogging && console.log(`[${this.sectionId}] ⏳ Waiting for cards... found ${cards.length}/${this.expectedCards}`);
                }
            });
            this.mutationObserver.observe(this, { childList: true, subtree: true });

            this.intersectionObserver = new IntersectionObserver(entries => {
                if (entries.some(entry => entry.isIntersecting)) {
                    if (this.equalizationReady) {
                        console.info(`[${this.sectionId}] 📡 Section entered viewport, re-running equalize`);
                        this.equalize("intersection");
                    }
                }
            }, { threshold: 0.1 });
            
            this.intersectionObserver.observe(this);

            // Orientation / Resize - only run equalize if ready
            window.addEventListener('resize', () => {
                if (this.equalizationReady) this.debouncedEqualize('resize');
            });
            window.addEventListener('orientationchange', () => {
                if (this.equalizationReady) this.equalize('orientationchange');
            });

            // ResizeObserver stays safe (optional to guard it too)
            this.resizeObserver = new ResizeObserver(() => {
                if (this.equalizationReady) this.equalize('resize-observer');
            });
            this.resizeObserver.observe(this);


            // Cleanup
            this.disconnectedCallback = () => {
                window.removeEventListener('resize', this.debouncedEqualize);
                window.removeEventListener('orientationchange', this.equalize);
                this.resizeObserver.disconnect();
                this.mutationObserver.disconnect();
            };
        }
        
        debouncedEqualize(source = 'resize') {
            clearTimeout(this._resizeTimeout);
            this._resizeTimeout = setTimeout(() => this.equalize(source), 300);
        }

        getCards() {
            return this.querySelectorAll('[data-wwai-container-card]');
        }

        discoverRoles() {
            const firstCard = this.querySelector('[data-wwai-container-card]');
            if (!firstCard) return [];

            return Array.from(firstCard.querySelectorAll('[data-wwai-container-card-role]'))
                .map(el => el.getAttribute('data-wwai-container-card-role'))
                .filter(role => !!role);
        }

        validateCards(roles) {
            const cards = this.getCards();
            cards.forEach(card => {
                roles.forEach(role => {
                    if (!card.querySelector(`[data-wwai-container-card-role="${role}"]`)) {
                        window.heightEqualizeLogging && console.log(`"[${this.sectionId}]"❌ Missing role "${role}" in card with label:`, card.dataset.wwaiContainerCardLabel);
                        window.heightEqualizeLogging && console.log(card);
                    }
                });
            });
        }

        equalize(source = 'unknown') {
            window.heightEqualizeLogging && console.log(`[${this.sectionId}] ⚡ Equalize triggered by: ${source}`);

            const cards = this.getCards();
            if (!cards.length) return;
        
            const roles = this.discoverRoles();
            if (!roles.length) return;
        
            // Validate cards
            this.validateCards(roles);
        
            // --- Step 1: Group cards by their top position (row)
            const rows = {};
            cards.forEach(card => {
                const top = Math.round(card.getBoundingClientRect().top); // round to avoid sub-pixel weirdness
                if (!rows[top]) rows[top] = [];
                rows[top].push(card);
            });
        
            // --- Step 2: For each row
            Object.values(rows).forEach(rowCards => {
        
                // Step 3: Equalize each role separately inside the row
                roles.forEach(role => {
                    let maxHeight = 0;
        
                    // Reset first
                    rowCards.forEach(card => {
                        const el = card.querySelector(`[data-wwai-container-card-role="${role}"]`);
                        if (el) el.style.minHeight = '';
                    });
        
                    // Find max height
                    rowCards.forEach(card => {
                        const el = card.querySelector(`[data-wwai-container-card-role="${role}"]`);
                        if (el) {
                            window.heightEqualizeLogging && console.log(`[${this.sectionId}] 📏 Measuring - Card Label: "${card.dataset.wwaiContainerCardLabel}", Role: "${role}", Offset Height: ${el.offsetHeight}px`);
                            maxHeight = Math.max(maxHeight, el.offsetHeight);
                        }
                    });
        
                    // Apply max height
                    rowCards.forEach(card => {
                        const el = card.querySelector(`[data-wwai-container-card-role="${role}"]`);
                        if (el) el.style.minHeight = `${maxHeight}px`;
                    });
        
                });
            });
        }    
    }

    window.ProductCustomHeightEqualizer = ProductCustomHeightEqualizer;

    if (!customElements.get('product-custom-height-equalizer')) {
        customElements.define('product-custom-height-equalizer', ProductCustomHeightEqualizer);
    }

    // Needed for case, when page loads, the section was already in viewport and visibility interection observer triggers before.
    document.addEventListener("DOMContentLoaded", () => {
        document.querySelectorAll('product-custom-height-equalizer').forEach(el => {
            const rect = el.getBoundingClientRect();
            const isVisible = rect.top < window.innerHeight && rect.bottom > 0;

            if (isVisible) {
                console.log(`[${el.sectionId}] 🕐 Detected section already in view on page load. Scheduling delayed equalize...`);
                setTimeout(() => {
                    console.log(`[${el.sectionId}] ⏳ Running delayed equalize after page load.`);
                    el.equalize('delayed-on-load');
                }, 500); // Adjust timing if needed
            }
        });
    });
}
(function () {
// Define event constants if not present
if (!window.WWAI_EVENTS) {
    window.WWAI_EVENTS = {
        /**
         * Fired when a full variant object is selected or changed.
         * This is the master event from which other updates cascade.
         */
        VARIANT_CHANGED: "product:variant_changed",

        /**
         * Fired when just the variant ID changes.
         * Shopify's Buy Button or native form listens to this.
         */
        VARIANT_ID_CHANGED: "product:variant_id_changed",

        /**
         * Fired when a variant's availability (in stock/out of stock) changes.
         * Also consumed by Shopify's native Buy Button logic.
         */
        VARIANT_AVAILABILITY_CHANGED: "product:variant_availability_changed",

        /**
         * Fired when a different subscription plan is selected (e.g., Monthly, Every 2 Weeks).
         */
        SUBSCRIPTION_PLAN_CHANGED: "product:subscription_selling_plan_changed",

        /**
         * Fired when a user switches between purchase types: one-time vs subscription.
         */
        PURCHASE_TYPE_CHANGED: "product:purchase_type_changed",

        /**
         * Fired when the displayed price changes.
         */
        PRICE_UPDATED: "product:price_updated",

        /**
         * Fired when subscription option UI (like a dropdown) updates after variant change.
         */
        SUBSCRIPTION_OPTIONS_UPDATED: "product:subscription_options_updated",

        /**
         * Fired when the labeled text (e.g., "$2.49 per dose") changes.
         */
        VARIANT_LABELED_TEXT_UPDATED: "product:variant_labeled_text_updated",

        /**
         * Fired when the active media (image/video/3D) changes.
         */
        MEDIA_CHANGED: "product:media_changed"
        };
}

// Define WWAIUtils namespace if not present
window.WWAIUtils = window.WWAIUtils || {};

// getSectionSpecificEventName
if (!window.WWAIUtils.getSectionSpecificEventName) {
    window.WWAIUtils.getSectionSpecificEventName = function (sectionId, label) {
    return `wwai_${label}_event_${sectionId}`;
    };
}

// sectionLevelDispatch (section-specific only)
if (!window.WWAIUtils.sectionLevelDispatch) {
    /**
     * Dispatches a section-specific namespaced event.
     * @param {string} sectionId - Shopify section ID.
     * @param {string} eventConstant - One of window.WWAI_EVENTS.* values.
     * @param {Object} detail - Payload to pass in the event.
     * @param {Element} [target=document] - DOM node to dispatch from (defaults to document).
     */
    window.WWAIUtils.sectionLevelDispatch = function (sectionId, eventConstant, detail, target) {
    var label = eventConstant;
    var sectionEventName = window.WWAIUtils.getSectionSpecificEventName(sectionId, label);

    var eventOptions = {
        detail: detail || {},
        bubbles: true,
        composed: true
    };

    var dispatchTarget = target || document;
    dispatchTarget.dispatchEvent(new CustomEvent(sectionEventName, eventOptions));
    };
}
})();

(function () {
window.WWAIUtils = window.WWAIUtils || {};

/**
 * Registers a section-scoped WWAI event listener for a given productGroup and event type.
 * Also tracks it in document.hasVariantChangeListener for initialization coordination.
 *
 * @param {string} sectionId - Shopify section ID
 * @param {string} productGroup - Logical product group (e.g. "dose-for-your-liver-product")
 * @param {string} eventConstant - One of window.WWAI_EVENTS.* (e.g. VARIANT_CHANGED)
 * @param {Function} handler - The callback to run when event is triggered
 */
window.WWAIUtils.registerSectionEventListener = function (sectionId, productGroup, eventConstant, handler) {
    if (!sectionId || !productGroup || !eventConstant || typeof handler !== "function") {
    console.warn("⚠️ registerSectionEventListener: Missing or invalid arguments.");
    return;
    }

    const eventLabel = eventConstant;
    const eventName = window.WWAIUtils.getSectionSpecificEventName(sectionId, eventLabel);
    const dispatchKey = `${sectionId}__${productGroup}`;

    document.addEventListener(eventName, function (e) {
    const eventDetail = e.detail || {};
    if (eventDetail.productGroup !== productGroup) return;

    handler(e);
    });

    // Only track listener registration for VARIANT_CHANGED events
    if (eventConstant === window.WWAI_EVENTS?.VARIANT_CHANGED) {
        document.hasVariantChangeListener = document.hasVariantChangeListener || {};
        document.hasVariantChangeListener[dispatchKey] = true;
    }

    if (window.customProductEventLoggingEnabled) {
    console.log(`✅ Listener registered for [${dispatchKey}] @ ${eventName}`);
    }
};
})();

// =============== Functions to dispatch the variant for each product group upon loading ========================

function areAllHandlesAvailableInGroup(productGroup) {
    const handles = window._WWAI_GROUP_TO_HANDLES?.[productGroup];
    
    if (!handles || handles.length === 0) {
        console.warn(`⚠️ Product group "${productGroup}" not found or empty in _WWAI_GROUP_TO_HANDLES.`);
        return false;
    }

    return handles.every(handle => window._WWAI_PRODUCT_AVAILABILITY?.[handle]);
}


(function () {
  window.WWAIUtils = window.WWAIUtils || {};

  if (typeof window.WWAIUtils.initializeVariantDispatch !== "function") {
    
    // Ensure we track default variant dispatch per section.
    document.hasDispatchedDefaultVariant = document.hasDispatchedDefaultVariant || {};

    // ✅ Function to wait for the variant change listener and dispatch default variant
    function waitForVariantChangeListenerAndDispatchDefaultVariant(sectionId, productGroup, retries = 20, delay = 200) {
        if (!sectionId || !productGroup) {
            console.error("❌ Both sectionId and productGroup are required.");
            return;
        }

        const sectionData = window.SECTION_DATA?.[sectionId];
        var dispatchConfig = sectionData?.variantDispatchConfig?.[productGroup];
        if (!dispatchConfig) {
            if (sectionData?.defaultVariantDispatchConfig) {
                window.variantDispatchLoggingEnabled && console.log(`[${sectionId}] 💤 Using default dispatchConfig for "${productGroup}"`);
                dispatchConfig = sectionData?.defaultVariantDispatchConfig;
            }
        }
        // Check if defaultVariant exists
        if (!dispatchConfig || !dispatchConfig.defaultProduct) {
            if (retries > 0) {
                window.variantDispatchLoggingEnabled && console.log(`[${sectionId}] 💤 Dispatch config missing for "${productGroup}", retrying in ${delay}ms...`);
                setTimeout(() => waitForVariantChangeListenerAndDispatchDefaultVariant(sectionId, productGroup, retries - 1, delay), delay);
            } else {
                console.error(`[${sectionId}] ❌ Dispatch config for "${productGroup}" not found. Event not dispatched.`);
            }
            return;
        }
        
        // Since some products are loaded programatically via API, make sure that product data exist before we dispatch default variant.
        const productsData = window.SECTION_DATA?.["all_sections"]?.storeData?.productGroups;
        if (!productsData) {
            console.error("❌ Product data is not initialized.");
        } else if (productsData.hasOwnProperty(productGroup) && Object.keys(productsData[productGroup]).length > 0 && areAllHandlesAvailableInGroup(productGroup)) {
            window.variantDispatchLoggingEnabled && console.log(`✅ Product group "${productGroup}" exists.`);
        } else {
            if (retries > 0) {
                window.variantDispatchLoggingEnabled && console.log(`[${sectionId}] 💤 Product data missing for "${productGroup}", retrying in ${delay}ms...`);
                setTimeout(() => waitForVariantChangeListenerAndDispatchDefaultVariant(sectionId, productGroup, retries - 1, delay), delay);
            } else {
                console.error(`[${sectionId}] ❌ Product data missing for "${productGroup}" not found. Event not dispatched.`);
            }
            return;
        }
        const dispatchKey = `${sectionId}__${productGroup}`;
        // Check if the listener exists, else we will fire the event before it can be caught by the corresponding handler.
        if (document.hasVariantChangeListener?.[dispatchKey]) {
            
            if (!document.hasDispatchedDefaultVariant[dispatchKey]) {
                window.variantDispatchLoggingEnabled && console.log(`[${sectionId}] ✅ Dispatching '${window.WWAI_EVENTS.VARIANT_CHANGED}' for group "${productGroup}"`);
                
                const keys = Object.keys(productsData);
                window.variantDispatchLoggingEnabled &&  console.log(`[${sectionId}] 🔑 All Product Group Keys:`, keys);
                window.variantDispatchLoggingEnabled &&  console.log(`[${sectionId}] 🔢 Number of Product Groups:`, keys.length);
                window.variantDispatchLoggingEnabled &&  console.log(`[${sectionId}] 🔍 Checking if productGroup exists:`, productGroup);
                
                if (keys.includes(productGroup)) {
                    window.variantDispatchLoggingEnabled &&  console.log(`[${sectionId}] ✅ Product group "${productGroup}" exists.`);
                    window.variantDispatchLoggingEnabled &&  console.log(`[${sectionId}] ℹ️ Data for "${productGroup}":`, productsData[productGroup]);
                } else {
                    window.variantDispatchLoggingEnabled &&  console.warn(`[${sectionId}] ❌ Product group "${productGroup}" does not exist.`);
                }

                window.WWAIUtils.sectionLevelDispatch(sectionId, window.WWAI_EVENTS.VARIANT_CHANGED, {
                    productGroup,
                    productTag: dispatchConfig.defaultProduct,
                    option1: dispatchConfig.defaultVariantOption1,
                    option2: dispatchConfig.defaultVariantOption2,
                    option3: dispatchConfig.defaultVariantOption3
                });

                // Mark that the event has been dispatched for this section
                document.hasDispatchedDefaultVariant[dispatchKey] = true;
            }
            return;
        }

        if (retries > 0) {
            window.variantDispatchLoggingEnabled && console.log(`[${sectionId}] Listener not found for "${productGroup}", retrying in ${delay}ms...`);
            setTimeout(() => waitForVariantChangeListenerAndDispatchDefaultVariant(sectionId, productGroup, retries - 1, delay), delay);
        } else {
            console.error(`[${sectionId}] ❌ Listener not found. Event not dispatched for "${productGroup}".`);
        }
    }

    window.WWAIUtils.initializeVariantDispatch = function (sectionId, productGroup) {
        if (!sectionId || !productGroup) {
            console.error("❌ Both sectionId and productGroup are required for initializeVariantDispatch");
            return;
        }

        window.SECTION_DATA = window.SECTION_DATA || {};
        window.SECTION_DATA[sectionId] = window.SECTION_DATA[sectionId] || {};

        const dispatchKey = `${sectionId}__${productGroup}`;
        document.hasDispatchedDefaultVariant = document.hasDispatchedDefaultVariant || {};
        document.hasDispatchedDefaultVariant[dispatchKey] = false;
        
        window.variantDispatchLoggingEnabled && console.log(`[${sectionId}] 🚀 Initializing variant dispatch for "${productGroup}"`);

        const runDispatch = () => {
            if (!document.hasDispatchedDefaultVariant[dispatchKey]) {
                waitForVariantChangeListenerAndDispatchDefaultVariant(sectionId, productGroup);
            }
        };

        // DOM ready handling
        if (document.readyState === "interactive" || document.readyState === "complete") {
            runDispatch();
        } 
        else {
            document.addEventListener("DOMContentLoaded", runDispatch);
        }

        // BFCache restore
        document.addEventListener("pageshow", (event) => {
            if (event.persisted && !document.hasDispatchedDefaultVariant[dispatchKey]) {
                window.variantDispatchLoggingEnabled && console.log(`[${sectionId}] ♻️ BFCache restored. Reapplying default variant for "${productGroup}"`);
                requestAnimationFrame(runDispatch);
            }
        });

    };
  }
})();


// =============== Utils to build variant to selling plan mapping and lookup selling plan. ===============

(function () {
window.WWAIUtils = window.WWAIUtils || {};

// Define only if not already defined
if (typeof window.WWAIUtils.mapVariantToSellingPlans !== "function") {
    window.WWAIUtils.mapVariantToSellingPlans = function (variants, sellingPlanGroups, removePrefix = null) {
    let variantSubscriptionMapping = {};

    variants.forEach(variant => {
        const variantId = variant.id;
        const variantTitle = variant.title;
        const basePrice = variant.price;
        let sellingPlans = [];

        const hasSubscription = Array.isArray(variant.selling_plan_allocations) && variant.selling_plan_allocations.length > 0;

        (variant.selling_plan_allocations || []).forEach(allocation => {
        const sellingPlanId = allocation.selling_plan_id;
        const priceAdjustments = allocation.price_adjustments || [];

        let firstOrderPrice = basePrice;
        let subsequentOrderPrice = null;

        priceAdjustments.forEach(adjustment => {
            if (adjustment.position === 1) {
            firstOrderPrice = adjustment.price;
            } else if (adjustment.position === 2) {
            subsequentOrderPrice = adjustment.price;
            }
        });

        if (subsequentOrderPrice === null) {
            subsequentOrderPrice = firstOrderPrice;
        }

        sellingPlanGroups.forEach(spGroup => {
            spGroup.selling_plans.forEach(sellingPlan => {
            if (sellingPlan.id === sellingPlanId) {
                let deliveryOption = sellingPlan.name;
                if (removePrefix && deliveryOption.startsWith(removePrefix)) {
                deliveryOption = deliveryOption.substring(removePrefix.length).trim();
                }

                sellingPlans.push({
                selling_plan_id: sellingPlanId,
                delivery_option: deliveryOption,
                base_price: basePrice,
                first_order_price: firstOrderPrice,
                subsequent_order_price: subsequentOrderPrice
                });
            }
            });
        });
        });

        variantSubscriptionMapping[`${variantId}, ${variantTitle}`] = {
        variant_id: variantId,
        variant_title: variantTitle,
        has_subscription: hasSubscription,
        selling_plans: sellingPlans
        };
    });

    return variantSubscriptionMapping;
    };
}

if (typeof window.WWAIUtils.lookupVariantSellingPlan !== "function") {
    window.WWAIUtils.lookupVariantSellingPlan = function (productGroup, productTag, variantId, variantTitle, useMockSubscription = false) {
        const key = `${productGroup}__${productTag}`;

        const mapping = window.SECTION_DATA?.["all_sections"]?.storeData?.variantSubscriptionMapping?.[key];
      
        if (!mapping) {
          console.warn(`⚠️ No variantSubscriptionMapping found for ${productGroup} / ${productTag}`);
          return null;
        }
      
        for (const key of Object.keys(mapping)) {
          const [keyVariantId, keyVariantTitle] = key.split(", ").map(str => str.trim());
      
          if (useMockSubscription) {
            if (keyVariantTitle === variantTitle) return mapping[key];
          } else {
            if (keyVariantId === String(variantId)) return mapping[key];
          }
        }
      
        return null;
      };
}

if (typeof window.WWAIUtils.updateVariantSubscriptionMapping !== "function") {
    window.WWAIUtils.updateVariantSubscriptionMapping = function () {
    
    if (!window.SECTION_DATA || !window.SECTION_DATA["all_sections"]) {
        console.error(`SECTION_DATA for all_sections not found.`);
        return;
    }

    const sectionData = window.SECTION_DATA["all_sections"];

    if (!sectionData?.storeData?.variantSellingPlans) {
        console.error(`❌ variantSellingPlans not found in storeData of all_sections`);
        return;
    }      

    sectionData.storeData.variantSubscriptionMapping = sectionData.storeData.variantSubscriptionMapping || {};

    Object.keys(sectionData.storeData.variantSellingPlans).forEach(productGroupAndKey => {
        const productData = sectionData.storeData.variantSellingPlans[productGroupAndKey];
        const variants = productData.variants || [];
        const sellingPlanGroups = productData.selling_plan_groups || [];

        sectionData.storeData.variantSubscriptionMapping[productGroupAndKey] = window.WWAIUtils.mapVariantToSellingPlans(
            variants,
            sellingPlanGroups
        );
    });

    if (window.customProductEventLoggingEnabled) {
        console.log(`✅ Updated variantSubscriptionMapping for:`, sectionData.storeData.variantSubscriptionMapping);
    }
    };
}
})();


// =============== Utils to infer currency and format price. ===============

(function () {
    // Ensure the WWAIUtils namespace exists
    window.WWAIUtils = window.WWAIUtils || {};

    /**
     * Extracts currency symbol and conversion factor from a formatted price string.
     * Example: "$12.34" → { symbol: "$", factor: 0.01 }
     */
    if (typeof window.WWAIUtils.inferCurrencyDetails !== "function") {
        window.WWAIUtils.inferCurrencyDetails = function (formattedPrice) {
        if (typeof formattedPrice !== "string" || formattedPrice.trim() === "") {
            console.error("❌ inferCurrencyDetails: Invalid formatted price input.");
            return { symbol: "$", factor: 0.01 };
        }

        const numberMatch = formattedPrice.match(/[\d,.]+/);
        const currencySymbol = formattedPrice.replace(numberMatch?.[0] || "", "").trim();
        const parsedNumber = numberMatch ? parseFloat(numberMatch[0].replace(/,/g, "")) : NaN;
        const conversionFactor = isNaN(parsedNumber) ? 0.01 : parsedNumber / 100;

        // Set globally for reuse
        window.CURRENCY_SYMBOL = currencySymbol;
        window.CURRENCY_FACTOR = conversionFactor;

        return {
            symbol: currencySymbol,
            factor: conversionFactor
        };
        };
    }

    /**
     * Formats a raw Shopify price (in cents) using the globally inferred currency symbol and factor.
     * Example: 1299 → "$12.99"
     */
    if (typeof window.WWAIUtils.formatShopifyPrice !== "function") {
        window.WWAIUtils.formatShopifyPrice = function (price) {
        if (typeof price !== "number" || isNaN(price)) {
            console.warn("⚠️ formatShopifyPrice: Invalid price input.");
            return "";
        }

        const symbol = window.CURRENCY_SYMBOL || "$";
        const factor = typeof window.CURRENCY_FACTOR === "number" ? window.CURRENCY_FACTOR : 0.01;
        const formatted = (price * factor).toFixed(2);

        return `${symbol}${formatted}`;
        };
    }
})();

(function() {
    window.WWAIUtils = window.WWAIUtils || {};

    // Define only if not already defined
    if (typeof window.WWAIUtils.getProductConfigForProductGroup !== "function") {
    /**
     * Returns product-specific config or default.
     */
    window.WWAIUtils.getProductConfigForProductGroup = function (sectionId, productGroup) {
        const sectionData = window.SECTION_DATA?.[sectionId];

        if (!sectionData) {
        console.warn(`⚠️ SECTION_DATA not found for section: ${sectionId}`);
        return null;
        }

        const groupConfig = sectionData.productGroupConfig?.[productGroup];
        if (groupConfig?.productConfig) {
        return groupConfig.productConfig;
        }

        if (sectionData.defaultProductConfig) {
        return sectionData.defaultProductConfig;
        }

        console.warn(`⚠️ No defaultProductConfig found for section: ${sectionId}`);
        return null;
    };
    }

    if (typeof window.WWAIUtils.getFlowConfigForProductGroup !== "function") {
    /**
     * Returns flow config for a product group, or fallback to default.
     */
    window.WWAIUtils.getFlowConfigForProductGroup = function (sectionId, productGroup) {
        const sectionData = window.SECTION_DATA?.[sectionId];

        if (!sectionData) {
        console.warn(`⚠️ SECTION_DATA not found for section: ${sectionId}`);
        return null;
        }

        const groupConfig = sectionData.productGroupConfig?.[productGroup];
        if (groupConfig?.flowConfig) {
        return groupConfig.flowConfig;
        }

        if (sectionData.defaultFlowConfig) {
        return sectionData.defaultFlowConfig;
        }

        console.warn(`⚠️ No defaultFlowConfig found for section: ${sectionId}`);
        return null;
    };
    }

})();
if (!window.__custom_elements_initialized__) {
window.__custom_elements_initialized__ = true;


function getSectionData(sectionId) {
  if (!window.SECTION_DATA || !window.SECTION_DATA[sectionId]) {
      console.warn(`⚠️ No data found for section "${sectionId}".`);
      return null;
  }
  return window.SECTION_DATA[sectionId];
}

function getAllSectionData() {
  // sectionId
  if (!window.SECTION_DATA || !window.SECTION_DATA["all_sections"]) {
      console.warn(`⚠️ No data found for section: all_sections.`);
      return null;
  }
  return window.SECTION_DATA["all_sections"];
}

function createVirtualBundleProduct(bundleKey, resolvedVariants, bundleItems) {
  // Aggregate title
  const titleParts = resolvedVariants.map(v => v?.title || "Unknown");
  const title = `wwai_bundle - ${titleParts.join(" + ")}`;

  // Compute prices and availability
  let totalPrice = 0;
  let totalCompareAtPrice = 0;
  let available = true;

  resolvedVariants.forEach((variant, idx) => {
      const quantity = bundleItems[idx]?.quantity || 1;

      // fallback compare_at_price if null
      const compareAt = variant.compare_at_price != null ? variant.compare_at_price : variant.price;

      totalPrice += (variant.price * quantity);
      totalCompareAtPrice += (compareAt * quantity);

      if (!variant.available) available = false;
  });

  // Output object
  return {
      id: `wwai_bundle_${bundleKey}`,
      title: title,
      available: available,
      price: totalPrice,
      compare_at_price: totalCompareAtPrice
  };
}

function getVirtualBundleIfExists(productGroup, productLabel) {
  if (window.WWAI_VIRTUAL_BUNDLE_CONFIG && window.WWAI_VIRTUAL_BUNDLE_CONFIG.hasOwnProperty(productGroup)) {
    
    const bundleItems = window.WWAI_VIRTUAL_BUNDLE_CONFIG[productGroup];
    const resolvedVariants = bundleItems.map(item => getProductVariant(item.handle, "product", ...item.variantOptions));
    const virtualProduct = createVirtualBundleProduct(productGroup, resolvedVariants, bundleItems);

    return { virtual_bundle_found: true, virtual_product: virtualProduct };
  } else {
      return { virtual_bundle_found: false, virtual_bundle: null };
  }
}

function getProductVariant(productGroup, productLabel, option1, option2 = null, option3 = null) {
  const globalSectionData = getAllSectionData();
  if (!globalSectionData || !globalSectionData.storeData || !globalSectionData.storeData.productGroups) {
    console.warn(`⚠️ Invalid globalSectionData.`);
    return null;
  }

  const groupData = globalSectionData.storeData.productGroups[productGroup];
  if (!groupData || !groupData[productLabel]) {
    console.warn(`⚠️ Product "${productLabel}" not found in product group "${productGroup}".`);
    return null;
  }

  const product = groupData[productLabel];
  const variants = product.variants || [];

  if (variants.length === 0) {
    const { virtual_bundle_found, virtual_product } = getVirtualBundleIfExists(productGroup, productLabel);
    if (virtual_bundle_found) {
        console.log(`[${productGroup}] ℹ️ Virtual bundle found.`, virtual_product);
        return virtual_product;
    }
    console.warn(`[${productGroup}]⚠️ No variants found for product "${productLabel}".`);
    return null;
  }

  // Normalize options for comparison
  const matchOptions = [option1, option2, option3].filter(opt => opt !== null && opt !== undefined).map(opt => opt.trim());
  
  if ( matchOptions.length === 1 && matchOptions[0] === "__wwai_first__") {
    if (window.customProductEventLoggingEnabled) {
      window.customProductEventLoggingEnabled && console.log(` Returning first variant due to __wwai_first__ directive.`);
    }
    return variants[0];
  }


  for (let variant of variants) {
    const variantOptions = [variant.option1, variant.option2, variant.option3].filter(opt => opt !== null && opt !== undefined).map(opt => opt.trim());

    // Check if variant options match exactly in order and value
    const isMatch = matchOptions.length === variantOptions.length &&
                    matchOptions.every((val, index) => val === variantOptions[index]);

    if (isMatch) {
      return variant;
    }
  }

  // Fallback: Return first variant if only one exists
  if (variants.length === 1) {
    return variants[0];
  }

  console.warn(`⚠️ No matching variant found for options [${matchOptions.join(', ')}] in product "${productLabel}" under group "${productGroup}".`);
  return null;
}

function getVariantSellingPlanInfo(productGroup, productLabel, selectedVariantJson) {
  const globalSectionData = getAllSectionData();

  const useMockSubscription = globalSectionData.storeData.useMockSubscription;

  if (!selectedVariantJson) {
    console.error(`❌ selectedVariantJson is required.`);
    return null;
  }

  const variantTitle = selectedVariantJson.title;
  const variantId = selectedVariantJson.id;

  window.customProductEventLoggingEnabled && console.log(`🔍 Looking up selling plan with:`, {
    productGroup,
    productLabel,
    variantTitle,
    variantId,
    useMockSubscription
  });
  // ✅ Delegate to WWAIUtils.lookupVariantSellingPlan
  const result = window.WWAIUtils.lookupVariantSellingPlan(
    productGroup,
    productLabel,
    variantId,
    variantTitle,
    useMockSubscription
  );

  return result;
}

function getProductMedia(productGroup, productLabel) {
  const globalSectionData = getAllSectionData();
  if (!globalSectionData || !globalSectionData.storeData || !globalSectionData.storeData.productGroups) {
    console.warn(`⚠️ Invalid globalSectionData.`);
    return null;
  }

  const groupData = globalSectionData.storeData.productGroups[productGroup];
  if (!groupData || !groupData[productLabel]) {
    console.warn(`⚠️ Product "${productLabel}" not found in product group "${productGroup}".`);
    return null;
  }

  const product = groupData[productLabel];

  // Ensure the product has media
  if (!product.media || product.media.length === 0) {
      console.warn(`⚠️ No media found for product "${productLabel}" in group "${productGroup}".`);
      return [];
  }

  return product.media; // Return media array
}

function calculateVariantPricesWithDiscounts(variant, sectionId, productGroup) {
  if (!variant || typeof variant.price !== "number") {
    console.error("❌ Invalid variant object provided.");
    return {
      price: "$0.00",
      compareAtPrice: "$0.00",
      discount_percent: "0.00"
    };
  }

  // Step 1: Resolve config and discount
  const config = window.WWAIUtils?.getProductConfigForProductGroup?.(sectionId, productGroup);
  const discountPercent = config?.discount_percent ? parseFloat(config.discount_percent) : 0;

  let basePrice = variant.price;
  let compareAtPrice = variant.compare_at_price || null;

  // Step 2: Apply discount logic
  if (discountPercent > 0) {
    compareAtPrice = Math.max(variant.price, variant.compare_at_price || 0);
    basePrice = compareAtPrice - (compareAtPrice * discountPercent / 100);
  }

  if (!compareAtPrice) {
    compareAtPrice = basePrice;
  }

  // Step 3: Compute final discount percent
  const computedDiscountPercent =
    compareAtPrice > 0 ? ((compareAtPrice - basePrice) / compareAtPrice) * 100 : 0;

  // Step 4: Format prices
  const formatFn = window.WWAIUtils?.formatShopifyPrice;
  if (typeof formatFn !== "function") {
    console.warn("⚠️ WWAIUtils.formatShopifyPrice is not defined. Returning unformatted price values.");
  }

  const discountPercentInt = parseInt(computedDiscountPercent, 10);

  const discount_percent = discountPercentInt === computedDiscountPercent
      ? discountPercentInt
      : computedDiscountPercent.toFixed(2);

  output =  {
    price: typeof formatFn === "function" ? formatFn(basePrice) : `${basePrice}`,
    compareAtPrice: typeof formatFn === "function" ? formatFn(compareAtPrice) : `${compareAtPrice}`,
    discount_percent: discount_percent
  };
  return output;
}

function getVariantSellingPlanOptionDetails(variantData, sectionId, productGroup) {
  if (!variantData || !Array.isArray(variantData.selling_plans)) {
    console.error("❌ Invalid variantData format. Expected 'selling_plans' array.");
    return [];
  }

  // Step 1: Get config and subscription discount
  const config = window.WWAIUtils?.getProductConfigForProductGroup?.(sectionId, productGroup);
  const subscriptionDiscountPercent = config?.subscription_discount_percent
    ? parseFloat(config.subscription_discount_percent)
    : 0;

  const prefixToRemove = config?.variant_option_remove_prefix || "";

  // Step 2: Check formatShopifyPrice availability
  const formatFn = window.WWAIUtils?.formatShopifyPrice;
  if (typeof formatFn !== "function") {
    console.warn("⚠️ WWAIUtils.formatShopifyPrice is not defined. Returning raw numbers as strings.");
  }

  // Step 3: Build transformed selling plan options
  return variantData.selling_plans.map((plan) => {
    const beforePrice = plan.base_price;
    let afterPrice = plan.first_order_price;

    // Apply additional subscription discount if specified
    if (subscriptionDiscountPercent > 0) {
      afterPrice = Math.round(afterPrice * (1 - subscriptionDiscountPercent / 100));
    }

    const computedDiscountPercent =
      beforePrice > 0 ? ((beforePrice - afterPrice) / beforePrice) * 100 : 0;

    // Clean option name by removing prefix if needed
    let optionName = plan.delivery_option || "";
    if (prefixToRemove && optionName.startsWith(prefixToRemove)) {
      optionName = optionName.substring(prefixToRemove.length).trim();
    }

    return {
      option_name: optionName,
      selling_plan_id: String(plan.selling_plan_id),
      before_price: typeof formatFn === "function" ? formatFn(beforePrice) : `${beforePrice}`,
      after_price: typeof formatFn === "function" ? formatFn(afterPrice) : `${afterPrice}`,
      discount_percent: computedDiscountPercent.toFixed(2),
    };
  });
}

function safelyDefineCustomElement(tagName, classRef) {
  if (!customElements.get(tagName)) {
    customElements.define(tagName, classRef);
  }
}

class ProductVariantSelector extends HTMLElement {
  constructor() {
    super();
    this.sectionId = this.getAttribute('section_id'); // Get section ID from the tag
    this.productGroup = this.getAttribute('product_group'); // Get section ID from the tag
  }

  connectedCallback() {
    if (!this.sectionId || !this.productGroup) {
      console.warn(`⚠️ <product-variant-selector> is missing required attributes: - section_id: ${this.sectionId} - product_group: ${this.productGroup} Variant selection will not work properly.`);
      return;
    }
    
    // Select all variant radio buttons inside this component
    this.variantRadioElements = this.querySelectorAll('input[type="radio"]');

    // Validate all radio buttons.
    this.validateAllElementAttributes();

    // Check input radio with same name does not exist anywhere else in the document.
    this.checkForConflictingRadioGroups();

    // Product radio and variant radio should not use same name.
    this.checkConsistentOptionTypeInRadioGroups();

    // ✅ Ensure autocomplete is off to prevent browser caching
    this.ensureAutocompleteOff();

    this.attachVariantRadioListeners();

    this.registerVariantChangeListener();
  }

  getSelectedProduct() {
    // Find the checked product-level radio input *inside this component*
    const selectedInput = this.querySelector(
      'input[type="radio"][data-wwai-product-variant-option-type="product"]:checked'
    );
  
    return selectedInput ? selectedInput.dataset.wwaiProductLabel : null;
  }

  getSelectedVariant() {
    // Get all variant-level radio inputs inside this component
    const variantInputs = this.querySelectorAll(
      'input[type="radio"][data-wwai-product-variant-option-type="product_variant"]'
    );
  
    if (variantInputs.length === 0) {
      console.warn(`⚠️ No variant radio inputs found inside <product-variant-selector> [${this.sectionId}].`);
      return null;
    }
  
    const selectedProductLabel = this.getSelectedProduct();
  
    if (!selectedProductLabel) {
      console.warn(`⚠️ No selected product found inside <product-variant-selector> [${this.sectionId}].`);
      return null;
    }
  
    for (let input of variantInputs) {
      const productLabel = input.getAttribute("data-wwai-product-label");
      const variantLabel = input.getAttribute("data-wwai-product-variant-label");
  
      if (productLabel === selectedProductLabel && input.checked) {
        return variantLabel;
      }
    }
  
    console.warn(`⚠️ No checked variant found for selected product "${selectedProductLabel}" in <product-variant-selector> [${this.sectionId}].`);
    return null;
  }
  
  setSelectedProduct(productLabel) {
    const productRadios = this.querySelectorAll(
      'input[type="radio"][data-wwai-product-variant-option-type="product"]'
    );  
    if (productRadios.length === 0) {
      console.warn(`⚠️ No product radio inputs found inside <product-variant-selector> [${this.sectionId}].`);
      return false;
    }
  
    let found = false;
  
    productRadios.forEach(input => {
      const label = input.getAttribute("data-wwai-product-label");
      if (label && label.trim() === productLabel.trim()) {
        input.checked = true;
        found = true;
      } else {
        input.checked = false;
      }
    });
  
    if (!found) {
      console.warn(`❌ No radio input matched product label: "${productLabel}" inside <product-variant-selector> [${this.sectionId}].`);
      return false;
    }
  
    window.customProductEventLoggingEnabled && console.log(`✅ Selected product set to "${productLabel}" in <product-variant-selector> [${this.sectionId}].`);
    return true;
  }

  setSelectedVariant(productLabel, productVariantLabel) {
    const variantRadios = this.querySelectorAll(
      'input[type="radio"][data-wwai-product-variant-option-type="product_variant"]'
    );

    if (variantRadios.length === 0) {
      console.warn(`⚠️ No variant radio inputs found in <product-variant-selector> [${this.sectionId}].`);
      return false;
    }

    let found = false;
    let selectedVariant = null;

    variantRadios.forEach((input, index) => {
      const inputProductLabel = input.getAttribute("data-wwai-product-label")?.trim();
      const inputVariantLabel = input.getAttribute("data-wwai-product-variant-label")?.trim();

      if (inputProductLabel === productLabel.trim()) {
        if (productVariantLabel === "__wwai_first__" && !found) {
          // Select first matching variant
          input.checked = true;
          found = true;
          selectedVariant = inputVariantLabel;
        } else if (inputVariantLabel === productVariantLabel.trim()) {
          input.checked = true;
          found = true;
          selectedVariant = inputVariantLabel;
        } else {
          input.checked = false;
        }
      }
    });

    if (!found) {
      console.warn(`[${this.sectionId}][${this.productGroup}]❌ No matching variant radio found for Product: "${productLabel}" | Variant: "${productVariantLabel}" in <product-variant-selector> .`);
      return false;
    }

    window.customProductEventLoggingEnabled && console.log(
      `✅ Selected variant updated to Product "${productLabel}" | Variant "${selectedVariant}" in <product-variant-selector> [${this.sectionId}].`
    );
    
    return selectedVariant; // ✅ Return the actual variant label selected
  }

  attachVariantRadioListeners() {
    this.variantRadioElements.forEach(element => {
      window.customProductEventLoggingEnabled &&
        console.log(`[${this.sectionId}][${this.productGroup}] Adding event listener to:`, this.getReadableVersionOfElement(element));
  
      element.addEventListener("change", (event) => {
        window.customProductEventLoggingEnabled &&
          console.log(`User changed the variant / [${this.sectionId}]:`, this.getReadableVersionOfElement(element));
  
        const selectedProduct = this.getSelectedProduct();
        const selectedVariant = this.getSelectedVariant();
  
        this.handleVariantChange(selectedProduct, selectedVariant);
      });
    });
  }

  registerVariantChangeListener() {
    if (!this.sectionId || !this.productGroup) {
      console.warn("⚠️ Missing sectionId or productGroup on <product-variant-selector>. Cannot register variant listener.");
      return;
    }
  
    if (window.WWAIUtils?.registerSectionEventListener && window.WWAI_EVENTS?.VARIANT_CHANGED) {
      window.WWAIUtils.registerSectionEventListener(
        this.sectionId,
        this.productGroup,
        window.WWAI_EVENTS.VARIANT_CHANGED,
        (e) => {
          window.variantConnectionLoggingEnabled && console.log(`[${this.sectionId}] / [${this.productGroup}] VARIANT_CHANGED connected → "`);

          const detail = e.detail || {};
  
          /** Extract variant info from the payload. */
          if (detail.option2 || detail.option3) {
            throw new Error(`[${this.sectionId}] ❌ Multi-level variant support (option2/option3) is not yet implemented.`);
          }
  
          const selectedProduct = detail.productTag?.trim?.();
          const selectedVariant = detail.option1?.trim?.();
  
          window.customProductEventLoggingEnabled &&
            console.log(`🧪 [${this.sectionId}] VARIANT_CHANGED received → Product: "${selectedProduct}", Variant: "${selectedVariant}"`);
  
          const productSet = this.setSelectedProduct(selectedProduct);
          // This handles the case like return the first matching element in UI.
          const selectedVariantLabel = this.setSelectedVariant(selectedProduct, selectedVariant); // now returns actual variant label or false
  
          if (productSet && selectedVariantLabel) {
            window.customProductEventLoggingEnabled &&
              console.log(`✅ Programmatically selected Product "${selectedProduct}" and Variant "${selectedVariantLabel}" in [${this.sectionId}]`);
          }
  
          this.handleVariantChange(selectedProduct, selectedVariantLabel);
        }
      );
    } else {
      console.warn(`⚠️ WWAIUtils.registerSectionEventListener or WWAI_EVENTS.VARIANT_CHANGED is not available for [${this.sectionId}]`);
    }
  }

  handleVariantChange(selectedProduct, selectedVariant) {
    const trimmedProduct = typeof selectedProduct === "string" ? selectedProduct.trim() : selectedProduct;
    const trimmedVariant = typeof selectedVariant === "string" ? selectedVariant.trim() : selectedVariant;
  
    if (window.customProductEventLoggingEnabled) {
      console.log(`🎯 [${this.sectionId}] Variant change received.`);
      console.log(`→ Product: "${trimmedProduct}", Variant: "${trimmedVariant}"`);
    }
  
    const result = this.resolveVariantAndSellingPlanInfo(trimmedProduct, trimmedVariant);
  
    if (!result || !result.productVariantJson) {
      console.error(`❌ [${this.sectionId}] Failed to resolve product variant for Product: "${trimmedProduct}", Variant: "${trimmedVariant}".`);
      return;
    }
  
    const { productVariantJson, sellingPlanInfo } = result;
  
    if (window.customProductEventLoggingEnabled) {
      console.log(`✅ [${this.sectionId}] Proceeding with resolved data.`);
      console.log("📦 productVariantJson:", productVariantJson);
      console.log("📦 sellingPlanInfo:", sellingPlanInfo ?? "⛔️ No subscription plans");
    }
    
    this.updateSelectedVariantText(selectedProduct, productVariantJson);

    // Update selling plan options if it exists, selling plan options update initializes the default purchase type and sets between one of 
    // one-time vs subscription, basis that the correct selling plan id is updated in the buy form for this product group. 
    // This also sets the prices for the selected subcription.
    if (sellingPlanInfo) {
      var selling_plan_options = getVariantSellingPlanOptionDetails(
        sellingPlanInfo,
        this.sectionId,
        this.productGroup
      );
      window.WWAIUtils.sectionLevelDispatch(this.sectionId, window.WWAI_EVENTS.SUBSCRIPTION_OPTIONS_UPDATED, {
        productGroup: this.productGroup,
        subscriptionOptions: selling_plan_options
      });
    }

    // Set the one time prices for the selcted variant.
    const { price, compareAtPrice, discount_percent } = calculateVariantPricesWithDiscounts(productVariantJson, this.sectionId, this.productGroup);
    window.WWAIUtils.sectionLevelDispatch(this.sectionId, window.WWAI_EVENTS.PRICE_UPDATED, {
      productGroup: this.productGroup,
      before_price: compareAtPrice ,
      after_price: price,
      discount_percent: discount_percent,
      label: "one_time"
    });

    // Update the availability status for the buy button, for the selected variant.
    window.WWAIUtils.sectionLevelDispatch(this.sectionId, window.WWAI_EVENTS.VARIANT_AVAILABILITY_CHANGED, {
      productGroup: this.productGroup,
      available: productVariantJson.available
    });

    // Update the variant id in the buy box, so correct item is added.
    window.WWAIUtils.sectionLevelDispatch(this.sectionId, window.WWAI_EVENTS.VARIANT_ID_CHANGED, {
      productGroup: this.productGroup,
      id: productVariantJson.id, 
      title: productVariantJson.title,
      product_tag: trimmedProduct,
      variant_tag: trimmedVariant
    });

    // At the end handle media change.
    this.handleMediaChangeForVariant(selectedProduct, productVariantJson);

    this.runEqualizeHeightForSection();
  }

  runEqualizeHeightForSection() {
    const cleanedSectionId = this.sectionId.replace('shopify-section-', '');
    const heightEqualizeSelector = document.querySelector(
      `product-custom-height-equalizer[section_id="${cleanedSectionId}"]`
    );
    if (heightEqualizeSelector) {
      console.log("Height equalize called from product update");
      heightEqualizeSelector.equalize("product_update");
    }
  }

  handleMediaChangeForVariant(selectedProduct, productVariantJson) {
    const mediaSelector = document.querySelector(
      `product-custom-media-gallery-for-grids[section_id="${this.sectionId}"][product_group="${this.productGroup}"]`
    );
    if (mediaSelector) {
      const selected_product_media = getProductMedia(this.productGroup, selectedProduct);
      const mediaId = productVariantJson.featured_media?.id || null;
      // On first init of variant, we hydrate, else we scroll.
      // The assunption is first image will be set correctly for first variant.
      mediaSelector.maybeHydrateOrScroll(selected_product_media, mediaId);
    }
  }

  updateSelectedVariantText(selectedProduct, productVariantJson) {
    const elements = this.querySelectorAll('[data-wwai-product-selected-variant-label]');

    if (elements.length === 0) {
        return;
    }

    if (elements.length > 1) {
        console.error('❌ Multiple elements found with [data-wwai-product-selected-variant-label]. Expected only one.');
        return;
    }

    const element = elements[0];
    element.textContent = productVariantJson.title;
}



  resolveVariantAndSellingPlanInfo(selectedProduct, selectedVariant) {
    const productVariantJson = getProductVariant(
      this.productGroup,
      selectedProduct,
      selectedVariant,
      null,
      null
    );
  
    if (!productVariantJson) {
      console.warn(`[${this.sectionId}][${this.productGroup}] ❌ Failed to resolve variant for Product: "${selectedProduct}" | Variant: "${selectedVariant}"`);
      return null;
    }
  
    const sellingPlanInfo = getVariantSellingPlanInfo(
      this.productGroup,
      selectedProduct,
      productVariantJson
    );
  
    if (window.customProductEventLoggingEnabled) {
      console.log(`[${this.sectionId}] 🧩 Resolved variant and selling plan info:`, {
        productVariantJson,
        sellingPlanInfo
      });
    }
  
    return {
      productVariantJson,
      sellingPlanInfo
    };
  }
  
  // Function: Get readable version of an element
  getReadableVersionOfElement(element) {
      const optionType = element.getAttribute('data-wwai-product-variant-option-type');
      const productLabel = element.getAttribute('data-wwai-product-label') || "Unknown Product";
      const variantLabel = element.getAttribute('data-wwai-product-variant-label') || "No Variant";

      if (optionType === "product") {
          return `Product: "${productLabel}"`;
      } else if (optionType === "product_variant") {
          return `Product: "${productLabel}" | Variant: "${variantLabel}"`;
      } else {
          return `Unknown Type - Product: "${productLabel}" | Variant: "${variantLabel}"`;
      }
  }

  /** ✅ Prevent browser autocomplete from affecting radio inputs */
  ensureAutocompleteOff() {
    this.variantRadioElements.forEach(radio => {
      if (!radio.hasAttribute("autocomplete")) {
        radio.setAttribute("autocomplete", "off");
      }
    });
  }

  checkForConflictingRadioGroups() {
    const conflicts = [];
  
    this.variantRadioElements.forEach(input => {
      const name = input.getAttribute("name");
      if (!name) return;
  
      const sameNameInputs = document.querySelectorAll(`input[type="radio"][name="${name}"]`);
  
      sameNameInputs.forEach(otherInput => {
        // It's a conflict ONLY IF the input is not contained inside this component
        if (!this.contains(otherInput)) {
          conflicts.push({
            input: input,
            conflictingElement: otherInput,
            name: name
          });
        }
      });
    });
  
    if (conflicts.length > 0) {
      console.warn(`⚠️ [${this.sectionId}] Conflicting radio 'name' attributes found across components!`);
      conflicts.forEach(({ name, input, conflictingElement }) => {
        console.warn(`🛑 Conflict for name="${name}"`);
        window.customProductEventLoggingEnabled && console.log("🔁 Internal input:", input);
        window.customProductEventLoggingEnabled && console.log("⛔ Conflicting input:", conflictingElement);
      });
    }
  }

  checkConsistentOptionTypeInRadioGroups() {
    const radioGroups = {};
  
    this.variantRadioElements.forEach(input => {
      const name = input.getAttribute("name");
      const optionType = input.getAttribute("data-wwai-product-variant-option-type");
  
      if (!name || !optionType) return;
  
      radioGroups[name] = radioGroups[name] || new Set();
      radioGroups[name].add(optionType);
    });
  
    Object.entries(radioGroups).forEach(([groupName, types]) => {
      if (types.size > 1) {
        console.warn(`⚠️ [${this.sectionId}] Inconsistent 'data-wwai-product-variant-option-type' in radio group "${groupName}".`);
        console.warn(`  → Found types: ${Array.from(types).join(", ")}`);
        
        const conflictingRadios = Array.from(this.variantRadioElements).filter(
          el => el.getAttribute("name") === groupName
        );
  
        conflictingRadios.forEach((el, i) => {
          console.warn(`  🔁 [${i + 1}]`, el);
        });
      }
    });
  }

  validateAllElementAttributes() {
    const invalidElements = [];
  
    this.variantRadioElements.forEach(element => {
      if (!this.validateElementAttributes(element)) {
        invalidElements.push(element);
      }
    });
  
    if (invalidElements.length > 0) {
      console.warn(`⚠️ Found ${invalidElements.length} invalid radio inputs inside <product-variant-selector> [${this.sectionId}]:`);
      invalidElements.forEach(el => {
        console.warn(this.getReadableVersionOfElement(el), el);
      });
    }
  
    return invalidElements.length === 0; // Returns true if all are valid
  }
  
  // ✅ Function: Validate required attributes (Supports "product" and "product_variant")
  validateElementAttributes(element) {
    const optionType = element.getAttribute('data-wwai-product-variant-option-type');
    const productLabel = element.getAttribute('data-wwai-product-label');
    const variantLabel = element.getAttribute('data-wwai-product-variant-label');

    // Ensure `optionType` is either "product" or "product_variant"
    if (optionType !== "product" && optionType !== "product_variant") {
        return false;
    }

    // Ensure `data-wwai-product-label` exists
    if (!productLabel) {
        return false;
    }

    // If it's a "product_variant", `data-wwai-product-variant-label` **must** be non-empty
    if (optionType === "product_variant" && !variantLabel) {
        return false;
    }

    // If it's a "product", `data-wwai-product-variant-label` **can be empty** (valid case)
    return true;
  }
}

class ProductCustomPurchaseTypeSelector extends HTMLElement {
  constructor() {
    super();
    this.sectionId = this.getAttribute("section_id"); // Get Section ID from the tag
    this.productGroup = this.getAttribute('product_group'); // Get product id from the tag
    this.subscriptionInput = null;
    this.onetimeInput = null;
  }

  connectedCallback() {
    if (!this.sectionId || !this.productGroup) {
      console.warn(`⚠️ <product-custom-purchase-type-selector> is missing required attributes: - section_id: ${this.sectionId} - product_group: ${this.productGroup}.`);
      return;
    }
  
    this.subscriptionInput = this.querySelector('input[type="radio"][data-wwai-subscription-purchase-type]');
    this.onetimeInput = this.querySelector('input[type="radio"][data-wwai-onetime-purchase-type]');

    if (!this.subscriptionInput || !this.onetimeInput) {
      console.error("❌ Missing required radio inputs inside <product-custom-purchase-type-selector>");
      return;
    }

    if (this.subscriptionInput.name !== this.onetimeInput.name) {
      console.error("❌ The radio buttons must have the same 'name' attribute.");
      return;
    }

    this.ensureAutocompleteOff();

    this.subscriptionInput.addEventListener("change", () => this.onUserSelectsSubscription());
    this.onetimeInput.addEventListener("change", () => this.onUserSelectsOnetime());

    if (window.WWAIUtils?.registerSectionEventListener && window.WWAI_EVENTS?.PURCHASE_TYPE_CHANGED) {
      window.WWAIUtils.registerSectionEventListener(
        this.sectionId,
        this.productGroup,
        window.WWAI_EVENTS.PURCHASE_TYPE_CHANGED,
        (e) => {
          this.onProgrammaticPurchaseTypeChange(e)
      });
    }
  }

  onUserSelectsSubscription() {
    this.onetimeInput.checked = false;

    const subscriptionSelector = document.querySelector(
      `product-custom-subscription-option-selector[section_id="${this.sectionId}"][product_group="${this.productGroup}"]`
    );
    
    if (subscriptionSelector) {
      subscriptionSelector.dispatchSubscriptionSellingPlanChange();
      window.customProductEventLoggingEnabled && console.log(subscriptionSelector.getSelectedOption());
    }
  }

  onUserSelectsOnetime() {
    this.subscriptionInput.checked = false;

    window.WWAIUtils.sectionLevelDispatch(this.sectionId, window.WWAI_EVENTS.SUBSCRIPTION_PLAN_CHANGED, {
      productGroup: this.productGroup,
      selling_plan_id: "",
      option_name: "One time purchase",
    });
  }

  onProgrammaticPurchaseTypeChange(event) {
    const { purchaseType } = event.detail;
    if (window.customProductEventLoggingEnabled) {
      window.customProductEventLoggingEnabled && console.log(`⚡ [${this.sectionId}] Programmatic purchase type change: ${purchaseType}`);
    }

    if (purchaseType === "subscription") {
      this.subscriptionInput.checked = true;
      this.onetimeInput.checked = false;
      this.onUserSelectsSubscription(); // trigger follow-up logic
    } else if (purchaseType === "onetime") {
      this.subscriptionInput.checked = false;
      this.onetimeInput.checked = true;
      this.onUserSelectsOnetime(); // trigger follow-up logic
    }
  }

  getSelectedPurchaseType() {
    if (this.subscriptionInput.checked) {
      return { purchaseType: "subscription" };
    } else if (this.onetimeInput.checked) {
      return { purchaseType: "onetime" };
    } else {
      console.warn("⚠️ No purchase type is selected. Defaulting to onetime.");
      return { purchaseType: "onetime" };
    }
  }

  ensureAutocompleteOff() {
    if (!this.subscriptionInput.hasAttribute("autocomplete")) {
      this.subscriptionInput.setAttribute("autocomplete", "off");
    }
    if (!this.onetimeInput.hasAttribute("autocomplete")) {
      this.onetimeInput.setAttribute("autocomplete", "off");
    }
  }
}


class ProductSubscriptionOptionsSelector extends HTMLElement {
  constructor() {
    super();
    this.sectionId = this.getAttribute('section_id');
    this.productGroup = this.getAttribute('product_group'); // Get product id from the tag
    this.selectElement = null;
  }

  connectedCallback() {
    if (!this.sectionId || !this.productGroup) {
      console.warn(`⚠️ <product-custom-subscription-option-selector> is missing required attributes: - section_id: ${this.sectionId} - product_group: ${this.productGroup}.`);
      return;
    }
    this.initializeSelectElement();
    this.ensureAutocompleteOff();
    this.setupSubscriptionOptionsChangedListener();
    this.setupSelectChangeListener();
  }

  initializeSelectElement() {
    this.selectElement = this.querySelector("[data-wwai-subscription-select]");
    if (!this.selectElement) {
      console.error("❌ <product-custom-subscription-option-selector>: Select element not found.");
    }
  }

  ensureAutocompleteOff() {
    if (this.selectElement && !this.selectElement.hasAttribute("autocomplete")) {
      this.selectElement.setAttribute("autocomplete", "off");
    }
  }

  setupSubscriptionOptionsChangedListener() {
    if (window.WWAIUtils?.registerSectionEventListener && window.WWAI_EVENTS?.SUBSCRIPTION_OPTIONS_UPDATED) {
      window.WWAIUtils.registerSectionEventListener(
        this.sectionId,
        this.productGroup,
        window.WWAI_EVENTS.SUBSCRIPTION_OPTIONS_UPDATED,
        (e) => {
          this.initAndUpdateSubscriptionOptions(e.detail.subscriptionOptions);
      });
    }
  }

  setupSelectChangeListener() {
    if (!this.selectElement) return;

    this.selectElement.addEventListener("change", () => {
      const selected = this.getSelectedOption();
      if (!selected) return;

      this.dispatchSubscriptionSellingPlanChange();
      this.dispatchSubscriptionPriceChange();
      this.ensurePurchaseTypeIsSubscription();
    });
  }

  /* Ensure "subscription" is selected if the user interacts with this dropdown */
  ensurePurchaseTypeIsSubscription() {
    const purchaseTypeSelector = document.querySelector(
      `product-custom-purchase-type-selector[section_id="${this.sectionId}"][product_group="${this.productGroup}"]`
    );
    const selectedPurchaseType = purchaseTypeSelector?.getSelectedPurchaseType();
    if (selectedPurchaseType?.purchaseType === "onetime") {
      window.customProductEventLoggingEnabled && console.log("🔄 Switching purchase type from 'onetime' to 'subscription'...");
      
      window.WWAIUtils.sectionLevelDispatch(this.sectionId, window.WWAI_EVENTS.PURCHASE_TYPE_CHANGED, {
        productGroup: this.productGroup,
        purchaseType: "subscription"
      });
    }
  }

  /* Update the subscription select dropdown */
  initAndUpdateSubscriptionOptions(subscriptionOptions) {
    if (!Array.isArray(subscriptionOptions)) {
      console.error("❌ Invalid subscription options payload.");
      return;
    }

    this.clearSelectOptions();

    subscriptionOptions.forEach((option) => {
      const optionEl = this.createOptionElement(option);
      this.selectElement.appendChild(optionEl);
    });

    this.dispatchSubscriptionPriceChange();

    const doesOneTimeSubSelectorExists = document.querySelector(
      `product-custom-purchase-type-selector[section_id="${this.sectionId}"][product_group="${this.productGroup}"]`
    ) !== null;
    
    if (!doesOneTimeSubSelectorExists) {
      window.customProductEventLoggingEnabled && console.log(`✅ <product-custom-purchase-type-selector> does not exists for [${this.sectionId}] and [${this.productGroup}], Sending subscription option update.`);
      this.dispatchSubscriptionSellingPlanChange();
    }
    
    initPurchaseTypeForProductGroup(this.sectionId, this.productGroup);
  }

  clearSelectOptions() {
    if (this.selectElement) {
      this.selectElement.innerHTML = "";
    }
  }

  createOptionElement(option) {
    const optionEl = document.createElement("option");
    optionEl.value = option.selling_plan_id;
    optionEl.textContent = option.option_name;

    optionEl.dataset.beforePrice = option.before_price;
    optionEl.dataset.afterPrice = option.after_price;
    optionEl.dataset.discountPercent = option.discount_percent;

    return optionEl;
  }

  getSelectedOption() {
    const selectedOption = this.selectElement?.options[this.selectElement.selectedIndex];
    if (!selectedOption) {
      console.warn("⚠️ No subscription option selected.");
      return null;
    }

    return {
      selling_plan_id: selectedOption.value,
      option_name: selectedOption.textContent.trim()
    };
  }

  dispatchSubscriptionSellingPlanChange() {
    const selected = this.getSelectedOption();
    if (!selected) return;

    window.WWAIUtils.sectionLevelDispatch(this.sectionId, window.WWAI_EVENTS.SUBSCRIPTION_PLAN_CHANGED, {
      productGroup: this.productGroup,
      selling_plan_id: selected.selling_plan_id,
      option_name: selected.option_name,
    });
 
  }

  dispatchSubscriptionPriceChange() {
    const selectedOption = this.selectElement?.options[this.selectElement.selectedIndex];
    if (!selectedOption) return;

    window.WWAIUtils.sectionLevelDispatch(this.sectionId, window.WWAI_EVENTS.PRICE_UPDATED, {
      productGroup: this.productGroup,
      before_price: selectedOption.dataset.beforePrice || null,
      after_price: selectedOption.dataset.afterPrice || null,
      discount_percent: selectedOption.dataset.discountPercent || null,
      label: "subscription"
    });
  }

  logSelectedOption() {
    const selected = this.getSelectedOption();
    if (selected && window.customProductEventLoggingEnabled) {
      window.customProductEventLoggingEnabled && console.log("🟢 Selected Option Data:", selected);
    }
  }
}

function initPurchaseTypeForProductGroup(sectionId, productGroup) {
  // Ensure utilities exist
  if (!window.WWAIUtils || typeof window.WWAIUtils.getProductConfigForProductGroup !== "function" || typeof window.WWAIUtils.sectionLevelDispatch !== "function") {
    console.error("❌ WWAIUtils methods are missing.");
    return;
  }

  const config = window.WWAIUtils.getProductConfigForProductGroup(sectionId, productGroup);
  if (!config) {
    console.error(`❌ Could not resolve product config for ${sectionId} / ${productGroup}`);
    return;
  }

  const defaultPurchaseType = config.default_purchase_type;

  // Validate
  if (defaultPurchaseType !== "subscription" && defaultPurchaseType !== "onetime") {
    console.error(`❌ Invalid default_purchase_type: "${defaultPurchaseType}" — expected 'subscription' or 'onetime'`);
    return;
  }

  // Dispatch section-scoped purchase type change
  window.WWAIUtils.sectionLevelDispatch(sectionId, window.WWAI_EVENTS.PURCHASE_TYPE_CHANGED, {
    productGroup,
    purchaseType: defaultPurchaseType
  });

  if (window.customProductEventLoggingEnabled) {
    window.customProductEventLoggingEnabled && console.log(`📢 Dispatched PURCHASE_TYPE_CHANGED for [${sectionId}] productGroup="${productGroup}"`);
    window.customProductEventLoggingEnabled && console.log("🟢 Payload:", { productGroup, purchaseType: defaultPurchaseType });
  }
}

class ProductCustomPriceSelector extends HTMLElement {
  constructor() {
    super();
    this.sectionId = this.getAttribute('section_id'); // Get Section ID from the tag
    this.productGroup = this.getAttribute('product_group'); // Get product id from the tag
  }

  connectedCallback() {
    if (!this.sectionId || !this.productGroup) {
      console.warn(`⚠️ <product-custom-price-selector> is missing required attributes: - section_id: ${this.sectionId} - product_group: ${this.productGroup}.`);
      return;
    }

    const elementsWithLabels = this.querySelectorAll("[data-wwai-product-price-label]");

    if (!elementsWithLabels.length) {
      console.warn("⚠️ No price-labeled elements found inside <product-custom-price-selector>");
      return;
    }
    this.validateLabeledPriceElements(elementsWithLabels);

    if (window.WWAIUtils?.registerSectionEventListener && window.WWAI_EVENTS?.PRICE_UPDATED) {
      window.WWAIUtils.registerSectionEventListener(
        this.sectionId,
        this.productGroup,
        window.WWAI_EVENTS.PRICE_UPDATED,
        (e) => {

          const { label, before_price, after_price, discount_percent } = e.detail || {};
    
          // If the label is not defined, log an error and skip
          if (!label) {
            console.error(`❌ [${this.sectionId}] PRICE_UPDATED event missing 'label'. Cannot update prices.`);
            return;
          }
    
          // Proceed to update the price UI
          this.updatePrices({ before_price, after_price, discount_percent }, label);
        }
      );
    } else {
      console.warn(`⚠️ PRICE_UPDATED listener could not be registered for section: ${this.sectionId}`);
    }
  }

  validateLabeledPriceElements(elementsWithLabels) {
    const labelMap = {};
  
    elementsWithLabels.forEach((el) => {
      const label = el.getAttribute("data-wwai-product-price-label");
      if (!labelMap[label]) {
        labelMap[label] = {
          before: false,
          after: false
        };
      }
  
      if (el.hasAttribute("data-wwai-product-before-price")) {
        labelMap[label].before = true;
      }
  
      if (el.hasAttribute("data-wwai-product-after-price")) {
        labelMap[label].after = true;
      }
    });
  
    Object.entries(labelMap).forEach(([label, flags]) => {
      if (!flags.before || !flags.after) {
        console.warn(
          `⚠️ In <product-custom-price-selector>, label "${label}" is missing required elements:`,
          {
            beforePriceMissing: !flags.before,
            afterPriceMissing: !flags.after
          }
        );
      }
    });
  }
  /**
   * Updates the prices and discount percentage in the UI.
   */
  updatePrices({ before_price, after_price, discount_percent }, label) {
    const elements = this.querySelectorAll(`[data-wwai-product-price-label="${label}"]`);
    if (!elements.length) {
      console.error(`❌ No elements found with data-wwai-product-price-label="${label}" inside <product-custom-price-selector> (section: ${this.sectionId}, group: ${this.productGroup})`);
      return;
  }  
  
    const discountPercentNumber = Number(discount_percent);
    const showDiscount = before_price !== after_price;
  
    elements.forEach((el) => {
      if (el.hasAttribute("data-wwai-product-before-price")) {
        el.textContent = showDiscount ? before_price : "";
      }
  
      if (el.hasAttribute("data-wwai-product-after-price")) {
        el.textContent = after_price;
      }

      if (el.hasAttribute("data-wwai-product-before-price-div")) {
        el.style.display = showDiscount ? '' : 'none';
      }
    
      if (el.hasAttribute("data-wwai-discount-percentage-div")) {
          el.style.display = showDiscount ? '' : 'none';
      }

      if (el.hasAttribute("data-wwai-discount-percentage")) {
        if (isNaN(discountPercentNumber)) {
          console.error("❌ Invalid discount_percent received:", discount_percent);
          return;
        }
  
        const formattedDiscount = `${discountPercentNumber}%`;
        const originalText = el.textContent.trim();
  
        if (showDiscount) {
          if (originalText.includes("(")) {
            el.textContent = originalText.replace(/\(\d+(\.\d+)?%\)/, `(${formattedDiscount})`);
          } else {
            el.textContent = formattedDiscount;
          }
        } else {
          el.textContent = "";
        }
      }
    });
  }
}

class ProductCustomAddToCartButton extends HTMLElement {
  constructor() {
    super();
    this.sectionId = this.getAttribute('section_id');
    this.productGroup = this.getAttribute('product_group');
  }

  connectedCallback() {
    if (!this.sectionId || !this.productGroup) {
      console.warn(`⚠️ <product-custom-add-to-cart-button> missing required attributes: section_id="${this.sectionId}", product_group="${this.productGroup}".`);
      return;
    }

    this.form = this.querySelector("form");
    if (!this.form) {
      console.error("❌ No <form> found inside <product-custom-add-to-cart-button>");
      return;
    }

    this.setupInputs();
    this.cacheElements();
    this.setupEventListeners();

    window.customProductEventLoggingEnabled && console.log("✅ Add-to-cart component initialized.");
  }

  setupInputs() {
    const requiredInputs = [
      { name: "id", type: "hidden" },
      { name: "selling_plan", type: "hidden" },
      { name: "quantity", type: "hidden", defaultValue: "1" }
    ];

    requiredInputs.forEach(({ name, type, defaultValue }) => {
      let input = this.form.querySelector(`input[name="${name}"]`);
      if (!input) {
        input = document.createElement("input");
        input.name = name;
        input.type = type;
        if (defaultValue) input.value = defaultValue;
        this.form.appendChild(input);

        window.customProductEventLoggingEnabled && console.log(`➕ Added missing input: ${name}`);
      }
    });

    this.variantIdInput = this.form.querySelector('input[name="id"]');
    this.sellingPlanInput = this.form.querySelector('input[name="selling_plan"]');
  }

  cacheElements() {
    this.button = this.form.querySelector('button[type="submit"]');
    if (!this.button) {
      console.error("❌ Submit button not found inside form.");
      return;
    }

    this.addToCartText = this.button.querySelector("[data-wwai-add-to-cart-text]");
    this.soldOutText = this.button.querySelector("[data-wwai-sold-out-text]");

    if (!this.addToCartText || !this.soldOutText) {
      console.warn("⚠️ One or both of the button text spans are missing.");
    }
  }

  setupEventListeners() {
    this.registerEvent(window.WWAI_EVENTS?.VARIANT_AVAILABILITY_CHANGED, this.onAvailabilityChanged.bind(this));
    this.registerEvent(window.WWAI_EVENTS?.VARIANT_ID_CHANGED, this.onVariantIdChanged.bind(this));
    this.registerEvent(window.WWAI_EVENTS?.SUBSCRIPTION_PLAN_CHANGED, this.onSellingPlanChanged.bind(this));
  }

  registerEvent(eventConstant, handler) {
    if (window.WWAIUtils?.registerSectionEventListener && eventConstant) {
      window.WWAIUtils.registerSectionEventListener(
        this.sectionId,
        this.productGroup,
        eventConstant,
        handler
      );
    } else {
      console.warn(`⚠️ Could not register ${eventConstant} listener for [${this.sectionId}].`);
    }
  }

  onAvailabilityChanged(e) {
    const { available } = e.detail;
    if (this.button) {
      this.button.disabled = !available;
      this.button.style.opacity = available ? "1" : "0.5";
    }

    if (this.addToCartText && this.soldOutText) {
      this.addToCartText.style.display = available ? "" : "none";
      this.soldOutText.style.display = available ? "none" : "";
    }

    window.customProductEventLoggingEnabled && console.log(`🟢 [${this.sectionId}] Variant availability updated: ${available}`);
  }

  onVariantIdChanged(e) {
    const { id, title, product_tag, variant_tag } = e.detail;
    if (this.variantIdInput) {
      this.variantIdInput.value = id;
      this.variantIdInput.dataset.title = title;
      this.variantIdInput.dataset.productTag = product_tag;
      this.variantIdInput.dataset.variantTag = variant_tag;
      this.variantIdInput.dataset.productGroupTag = this.productGroup;
      window.customProductEventLoggingEnabled && console.log(`🔁 [${this.sectionId}] Updated variant ID to: ${id}, Title: ${title}`);
    }
  }

  onSellingPlanChanged(e) {
    const { selling_plan_id, option_name } = e.detail;
    if (this.sellingPlanInput) {
      this.sellingPlanInput.value = selling_plan_id;
      this.sellingPlanInput.dataset.option_name = option_name;
      window.customProductEventLoggingEnabled && console.log(`🔁 [${this.sectionId}] Updated selling plan ID to: ${selling_plan_id}, Option: ${option_name}`);
    }
  }
}

function isVirtualBundleProduct(variantId) {
  return typeof variantId === 'string' && variantId.startsWith("wwai_bundle_");
}


function getItemsToAddInVirtualProduct(productGroup) {
  if (!window.WWAI_VIRTUAL_BUNDLE_CONFIG || !window.WWAI_VIRTUAL_BUNDLE_CONFIG.hasOwnProperty(productGroup)) {
      console.error(`❌ Bundle config missing for "${productGroup}"`);
      return [];
  }

  const bundleItems = window.WWAI_VIRTUAL_BUNDLE_CONFIG[productGroup];
  const resolvedVariants = bundleItems.map(item => getProductVariant(item.handle, "product", ...item.variantOptions));

  return resolvedVariants.map((variant, idx) => {
      if (!variant || !variant.id) {
          console.error(`❌ Could not resolve variant for bundle item ${bundleItems[idx].handle}`);
          return null; // will be filtered out
      }

      return {
          id: variant.id,
          quantity: bundleItems[idx].quantity || 1
      };
  }).filter(item => item !== null);
}

    function createCartFormData(items) {
  const formData = new FormData();

  items.forEach((item, index) => {
    formData.append(`items[${index}][id]`, item.id);
    formData.append(`items[${index}][quantity]`, item.quantity || 1);
  });

  formData.append("sections", "cart-drawer,cart-icon-bubble");
  formData.append("sections_url", "/pages/miyuki-launch-page");

  return formData;
}

class WWAINewWestSideCartIntegration {
  constructor(submitButton) {
    this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    this.submitButton = submitButton;

    if (document.querySelector('cart-drawer')) {
      this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }
  }

  async onSubmitHandler(itemsToAdd) {
    this.submitButton.classList.add('loading');
    const formData = createCartFormData(itemsToAdd);

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    config.body = formData;

    if (this.cart) {
      this.cart.setActiveElement(document.activeElement);
    }

    try {
      const response = await fetch(`${routes.cart_add_url}`, config).then(res => res.json());

      if (response.status) {
        this.handleCartError(response, formData);
        return;
      }

      if (!this.cart) {
        window.location = window.routes.cart_url;
        return;
      }

      this.handleCartSuccess(response, formData);
    } catch (error) {
      console.error("❌ Cart API Error:", error);
    } finally {
      this.submitButton.classList.remove('loading');

      if (this.cart?.classList.contains('is-empty')) {
        this.cart.classList.remove('is-empty');
      }

      if (!this.error) {
        this.submitButton.removeAttribute('aria-disabled');
      }
    }
  }

  handleCartError(response, formData) {
    publish(PUB_SUB_EVENTS.cartError, {
      source: 'product-form',
      productVariantId: formData.get('id'),
      errors: response.errors || response.description,
      message: response.message,
    });

    this.handleErrorMessage(response.description);

    const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
    if (soldOutMessage) {
      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.querySelector('span')?.classList.add('hidden');
      soldOutMessage.classList.remove('hidden');
    }

    this.error = true;
  }

  handleCartSuccess(response, formData) {
    if (!this.error) {
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'product-form',
        productVariantId: formData.get('id'),
        cartData: response,
      });
    }

    this.error = false;

    const quickAddModal = this.closest?.('quick-add-modal');
    if (quickAddModal) {
      document.body.addEventListener(
        'modalClosed',
        () => setTimeout(() => this.cart.renderContents(response)),
        { once: true }
      );
      quickAddModal.hide(true);
    } else {
      this.cart.renderContents(response);
    }
  }
}
  

  
class ProductCustomSubmitInterceptor extends HTMLElement {
  constructor() {
    super();
    this.sectionId = this.getAttribute('section_id');
    this.productGroup = this.getAttribute('product_group');
    this.flowConfig = window.WWAIUtils?.getFlowConfigForProductGroup?.(this.sectionId, this.productGroup) || {};
    this.deployMode = window.SECTION_DATA?.["all_sections"]?.storeData.deployMode;
  }

  connectedCallback() {
    if (!this.sectionId || !this.productGroup) {
      console.warn(`⚠️ <product-custom-add-to-cart-button> missing required attributes: section_id="${this.sectionId}", product_group="${this.productGroup}".`);
      return;
    }

    this.formElement = this.querySelector("form");
    this.submitButton = this.formElement?.querySelector('button[type="submit"]');
    this.variantInput = this.formElement?.querySelector('input[name="id"]');
    this.sellingPlanInput = this.formElement?.querySelector('input[name="selling_plan"]');
    this.quantityInput = this.formElement?.querySelector('input[name="quantity"]');

    if (!this.formElement || !this.submitButton) {
      console.error("❌ Missing form or submit button inside <product-custom-submit-interceptor>");
      return;
    }

    this.formElement.addEventListener("submit", (event) => this.handleSubmit(event));
  }

  handleSubmit(event) {
    event.preventDefault(); // Stop submission

    if (!this.deployMode) {
      event.preventDefault(); // Stop submission
      this.showPopup("⚠️ Error: `deploy_mode` is not set!", "error", true);
      console.error("❌ `deploy_mode` is missing in SECTION_DATA. Submission blocked.");
      return;
    }

    const title = this.variantInput?.dataset.title || "Unknown Product";
    const optionName = this.sellingPlanInput?.dataset.option_name || "One-time purchase";
    const quantity = this.quantityInput?.value || "1"; // Default to 1 if missing
    const productTag = this.variantInput?.dataset.productTag;
    const variantTag = this.variantInput?.dataset.variantTag;
    const productGroupTag = this.variantInput?.dataset.productGroupTag;

    const variantId = this.variantInput?.value;
    if (!variantId) {
        console.error("❌ No variant selected.");
        return;
    }
    const isBundle = isVirtualBundleProduct(variantId);
    const items = this.itemsToAdd();

    if (this.deployMode === "local") {
      event.preventDefault(); // Prevent actual submission
      if (isBundle) {
        const productGroupTag = variantId.replace("wwai_bundle_", "");
        const bundleSummary = items.map(item => `${item.quantity} x ${item.id}`).join(", ");
        
        this.showPopup(`🛍️ Simulating add-to-cart (BUNDLE): ${productGroupTag} → ${bundleSummary}`);    
      }
      else {
        this.showPopup(`🛍️ Simulating add-to-cart: ${productGroupTag}  - ${title} - ${optionName} (Qty: ${quantity})`);
        window.customProductEventLoggingEnabled && console.log(`🛍️ [LOCAL] Would have added to cart: ${title} - ${optionName} (Qty: ${quantity})`);  
      }
      return;
    } else if (this.deployMode === "sandbox") {
      if (this.sellingPlanInput?.value) {
        event.preventDefault(); // Temporarily prevent submission
        const removedPlan = this.sellingPlanInput.value;
        window.customProductEventLoggingEnabled && console.log(`🛠️ [SANDBOX] Clearing selling_plan_id: ${removedPlan}`);

        this.showPopup(`${title} - ${optionName} (Qty: ${quantity}) / ⚠️ Removing Selling Plan: ${removedPlan}`, "warning", true);

        setTimeout(() => {
          this.sellingPlanInput.value = ""; // Remove selling plan
          console.log("Removing selling plan.");
          window.customProductEventLoggingEnabled && console.log(`✅ Selling plan removed: ${removedPlan}`);
          this.proceedWithSubmission(this.formElement, this.submitButton, event, this.flowConfig);
        }, 3000);
        return;
      }
    }
    // If no selling plan in sandbox or inn prod, let the normal form submission proceed
    this.proceedWithSubmission(this.formElement, this.submitButton, event, this.flowConfig);
  }

  itemsToAdd() {
    const variantId = this.variantInput?.value;
    const quantity = Number(this.quantityInput?.value) || 1;
    const sellingPlan = this.sellingPlanInput?.value || null;

    if (!variantId) {
        console.error("❌ No variant selected. Cannot proceed.");
        return [];
    }

    if (isVirtualBundleProduct(variantId)) {
        const productGroup = variantId.replace("wwai_bundle_", "");
        return getItemsToAddInVirtualProduct(productGroup);
    }

    // Normal product case
    const item = {
        id: variantId,
        quantity: quantity
    };

    if (sellingPlan) {
        item.selling_plan = sellingPlan;
    }

    return [item];
  }

  proceedWithSubmission(formElement, submitButton, originalEvent, flowConfig) {
    const use_mock = false; // ✅ set to false when you're ready for real behavior

    const items = this.itemsToAdd();
    if (!items.length) return;

    const variantId = this.variantInput?.value;
    const shouldHandleAsync = true;
      // flowConfig.destination === "checkout" || isVirtualBundleProduct(variantId);

    // 🪵 Log summary
    console.group(`[submit] ➜ ProductGroup: ${this.productGroup || "unknown"}`);
    console.log("🧩 Items to Add:", items);
    console.log("🛠️ Destination:", flowConfig.destination);
    console.log("🌀 Async Flow Needed:", shouldHandleAsync);
    console.log("🔁 Submit Button:", submitButton);
    console.log("🧪 use_mock mode:", use_mock);
    console.groupEnd();

    if (use_mock) {
        originalEvent.preventDefault();
        console.info("✅ [MOCK] Skipping actual submission due to use_mock = true.");
        return;
    }

        
    if (shouldHandleAsync) {
        originalEvent.preventDefault();
        // this.handleAsyncAddToCartAndRedirect(flowConfig.destination, submitButton, items);
      const cartHandler = new WWAINewWestSideCartIntegration(submitButton);
        cartHandler.onSubmitHandler(items); // 👈 calls the real handler
      
    } else {
        formElement.submit();
    }
  }

  async handleAsyncAddToCartAndRedirect(destination, submitButton, items) {
    submitButton?.classList.add("loading");

    try {
        await this.addItemsToCart(items);

        if (destination === "checkout") {
            this.redirect("/checkout");
        } else if (destination === "cart") {
            this.redirect("/cart");
        } else {
            console.warn(`⚠️ Unknown destination "${destination}". No redirect performed.`);
        }

    } catch (err) {
        console.error("❌ Failed to add to cart:", err);
        this.showPopup("Error adding to cart. Please try again.", "error", true);
    } finally {
        submitButton?.classList.remove("loading");
    }
  }
  
  addItemsToCart(items) {
    return fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items })
    })
    .then(res => {
        if (!res.ok) throw new Error("Add to cart failed");
        return res.json();
    });
  }

  redirect(path) {
      window.location.href = path;
  }

  showPopup(message, type = "success", centered = false) {
    let popup = document.createElement("div");
    popup.textContent = message;
    popup.style.cssText = `
      position: fixed;
      ${centered ? "top: 50%; left: 50%; transform: translate(-50%, -50%);" : "bottom: 20px; right: 20px;"}
      background: ${type === "error" ? "#D9534F" : type === "warning" ? "rgb(87, 102, 92)" : "#333"};
      color: white;
      padding: 15px 20px;
      border-radius: 5px;
      font-size: 16px;
      font-weight: bold;
      text-align: center;
      z-index: 9999;
      opacity: 1;
      transition: opacity 0.5s ease-in-out;
    `;

    document.body.appendChild(popup);
    setTimeout(() => {
      popup.style.opacity = "0";
      setTimeout(() => popup.remove(), 500);
    }, 2000);
  }
}

function normalizeUrl(url) {
  if (!url) return '';

  try {
      const u = new URL(url.startsWith('//') ? 'https:' + url : url);
      const path = u.pathname;

      // Find the last occurrence of /files/
      const index = path.lastIndexOf('/files/');

      if (index !== -1) {
          return path.substring(index);  // get from the last /files/ onwards
      } else {
          return path; // fallback to full path if /files/ is missing
      }
  } catch (e) {
      return url;
  }
}

class ProductMediaGalleryForGrids extends HTMLElement {
  constructor() {
    super();
    this.sectionId = this.getAttribute('section_id');
    this.productGroup = this.getAttribute('product_group');
    this.hydrationDone = false; // ✅ hydration flag
  }

  connectedCallback() {
    if (!this.sectionId || !this.productGroup) {
      console.warn(`⚠️ <product-custom-media-gallery-for-grids> missing required attributes: section_id="${this.sectionId}", product_group="${this.productGroup}".`);
      return;
    }

    const container = this.querySelector('[data-wwai-media-container]');
    if (!container) {
      return console.error(`["${this.sectionId}"]["${this.productGroup}"]: Missing media container`);
    }
    this.container = container;

    const existingSlide = container.querySelector('.product-section-media');
    if (!existingSlide) {
      return console.error(`["${this.sectionId}"]["${this.productGroup}"]: Alteast one slide should be present`);
    }
    this.firstSlide = existingSlide;
  }

  hydrateRemainingMedia(productMedia = []) {
    if (!Array.isArray(productMedia) || productMedia.length === 0) {
      console.warn(`[${this.sectionId}] ⚠️ Invalid or empty media array passed to hydrateRemainingMedia()`);
      return;
    }    
      // Step 1: Filter only image-type media
      const imageMedia = productMedia.filter(media => media.media_type === 'image');
  
      // Step 2: Get the src from the existing first slide's image
      const imgEl = this.firstSlide.querySelector('img');
      if (!imgEl) {
        console.warn(`[${this.sectionId}] ⚠️ No <img> found inside the first slide.`);
        return;
      }
      const firstSlideSrc = imgEl.getAttribute('src') || '';
  
      // Step 3: Match it to the media
      const normalizedFirstSlideSrc = normalizeUrl(firstSlideSrc);

      const matchedMedia = imageMedia.find(media => {
          const mediaSrc = normalizeUrl(media.preview_image?.src);
          return normalizedFirstSlideSrc.includes(mediaSrc);
      });

      if (matchedMedia) {    
        if (!this.firstSlide.hasAttribute('data-wwai-carousel-media-id')) {
            this.firstSlide.setAttribute('data-wwai-carousel-media-id', matchedMedia.id);
            console.log(`[${this.sectionId}] 🟢 Attached data-wwai-carousel-media-id="${matchedMedia.id}" to first slide.`);
        }
      } else {
          console.warn(`[${this.sectionId}] ❌ No matching media found for first slide`);
      }

      // Step 5: Hydrate remaining
      const remainingMedia = matchedMedia
        ? imageMedia.filter(media => media.id !== matchedMedia.id)
        : imageMedia;
    
      remainingMedia.forEach(media => {
          const newSlide = this.createSlide(media);
          this.firstSlide.parentElement.appendChild(newSlide);
      });
      this.hydrationDone = true; // ✅ mark as hydrated
  }

  createSlide(media) {
    const newSlide = this.firstSlide.cloneNode(true);

    newSlide.removeAttribute('id');
    // Step 1: Remove ALL data-* attributes except data-wwai-carousel-media-id
    Array.from(newSlide.attributes).forEach(attr => {
        if (attr.name.startsWith('data-') && attr.name !== 'data-wwai-carousel-media-id') {
            newSlide.removeAttribute(attr.name);
        }
    });

    // Step 2: Set the correct media id
    newSlide.setAttribute('data-wwai-carousel-media-id', media.id);

    // Step 3: Update the <img> inside
    const img = newSlide.querySelector('img');
    if (!img) return null;

    // Clean up img attributes
    Array.from(img.attributes).forEach(attr => {
        if (attr.name.startsWith('data-')) {
            img.removeAttribute(attr.name);
        }
    });

    // Step 4: Update src
    img.src = media.preview_image?.src || '';

    // Step 5: Rebuild srcset from existing widths
    const originalSrcset = img.getAttribute('srcset') || '';
    const widths = Array.from(originalSrcset.matchAll(/(\d+)w/g)).map(match => parseInt(match[1]));

    const baseSrc = media.preview_image?.src?.split('?')[0]; // remove query params if any

    if (baseSrc && widths.length > 0) {
        const newSrcset = widths.map(w => `${baseSrc}?width=${w} ${w}w`).join(', ');
        img.setAttribute('srcset', newSrcset);
    }

    img.setAttribute('loading', 'lazy');

    return newSlide;
  }

  scrollToMediaById(mediaId) {
    if (!this.container) {
        console.warn(`[${this.sectionId}] ⚠️ Media container not found`);
        return;
    }

    const targetSlide = this.container.querySelector(`[data-wwai-carousel-media-id="${mediaId}"]`);
    if (!targetSlide) {
        console.warn(`[${this.sectionId}] ⚠️ Slide with mediaId=${mediaId} not found`);
        return;
    }

    
    const targetLeft = targetSlide.getBoundingClientRect().left - this.container.getBoundingClientRect().left + this.container.scrollLeft;
    console.log("updated scroll type:", targetLeft);
    
    // Do the scroll
    this.container.scrollTo({ left: targetLeft, behavior: 'smooth' });
  }

  maybeHydrateOrScroll(productMedia = [], mediaId) {
    if (!this.hydrationDone) {
        console.log(`[${this.sectionId}] 💧 Hydrating (scroll will be skipped)...`);
        this.hydrateRemainingMedia(productMedia);
        return; // ✅ Exit after hydration, do not scroll immediately
    }

    // ✅ Only scroll if already hydrated
    if (mediaId) {
        this.scrollToMediaById(mediaId);
    } else {
        console.log(`[${this.sectionId}] ⚠️ No media ID provided for scroll`);
    }
  }
}

safelyDefineCustomElement("product-custom-media-gallery-for-grids", ProductMediaGalleryForGrids);

// Variant.
safelyDefineCustomElement("product-variant-selector", ProductVariantSelector);

// Subscription .
safelyDefineCustomElement("product-custom-subscription-option-selector", ProductSubscriptionOptionsSelector);
safelyDefineCustomElement("product-custom-purchase-type-selector", ProductCustomPurchaseTypeSelector);

// Prices
safelyDefineCustomElement("product-custom-price-selector", ProductCustomPriceSelector);

// Add to cart form.
safelyDefineCustomElement("product-custom-add-to-cart-button", ProductCustomAddToCartButton);

// Add to cart interceptor.
safelyDefineCustomElement("product-custom-submit-interceptor", ProductCustomSubmitInterceptor);
}